"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4801],{

/***/ 6824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* reexport */ esm_Gpt; },
  "o": function() { return /* reexport */ esm_GptProcessor; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
;// CONCATENATED MODULE: ./node_modules/@pcln/ad-unit/dist/esm/Gpt.js
var Gpt=function Gpt(props){return/*#__PURE__*/react.createElement(Box/* default */.Z,null,props.render());};Gpt.displayName='Gpt';Gpt.propTypes={render:(prop_types_default()).func.isRequired};/* harmony default export */ var esm_Gpt = (Gpt);
//# sourceMappingURL=Gpt.js.map
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(60136);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(82963);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(61120);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
;// CONCATENATED MODULE: ./node_modules/@pcln/ad-unit/dist/esm/GptManager.js
/****
 *
 *  GPT file as a singleton
 *
 */var GptManager=/*#__PURE__*/function(){function GptManager(){(0,classCallCheck/* default */.Z)(this,GptManager);if(arguments[0]!=='__getInstance__'){throw Error('Do not instantiate directly use getInstance');}this.gptScript=null;}(0,createClass/* default */.Z)(GptManager,[{key:"initScriptTag",value:function initScriptTag(){this.setGptScript();return this.loadScript().then(function(){if(!window.googletag){throw Error('Failed to init GPT');}return window.googletag;}).catch(function(err){throw err;});}},{key:"setGptScript",value:function setGptScript(){this.gptScript='//www.googletagservices.com/tag/js/gpt.js';}},{key:"loadScript",value:function loadScript(){var _this=this;return new Promise(function(resolve,reject){var element=document.createElement('script');var target=document.getElementsByTagName('script')[0];element.src=_this.gptScript;element.async=true;element.type='text/javascript';element.onload=resolve;element.onerror=reject;target.parentNode.insertBefore(element,target);});}}],[{key:"createInstance",value:function createInstance(){return new GptManager(arguments[0]);}},{key:"getGptInstance",value:function getGptInstance(callback){if(!window.googletag){var instance=GptManager.createInstance('__getInstance__');instance.initScriptTag().then(function(){return callback(null,window.googletag);}).catch(function(err){throw err;});}else{return callback(null,window.googletag);}}}]);return GptManager;}();/* harmony default export */ var esm_GptManager = (GptManager);
//# sourceMappingURL=GptManager.js.map
;// CONCATENATED MODULE: ./node_modules/@pcln/ad-unit/dist/esm/GptProcessor.js
function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=(0,getPrototypeOf/* default */.Z)(Derived),result;if(hasNativeReflectConstruct){var NewTarget=(0,getPrototypeOf/* default */.Z)(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return (0,possibleConstructorReturn/* default */.Z)(this,result);};}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}var GptProcessor=/*#__PURE__*/function(_React$Component){(0,inherits/* default */.Z)(GptProcessor,_React$Component);var _super=_createSuper(GptProcessor);function GptProcessor(){(0,classCallCheck/* default */.Z)(this,GptProcessor);return _super.apply(this,arguments);}(0,createClass/* default */.Z)(GptProcessor,[{key:"componentDidMount",value:function componentDidMount(){var _this=this;esm_GptManager.getGptInstance(function(err,googletag){if(err){console.warn('Error on mount: ',err);return;}_this.appendCmd(googletag);_this.mountAd(googletag);});}},{key:"render",value:function render(){return/*#__PURE__*/react.createElement(Box/* default */.Z,{id:this.props.gptId});}},{key:"addSlotRenderEndedListener",value:function addSlotRenderEndedListener(googletag){var _this2=this;googletag.pubads().addEventListener('slotRenderEnded',function(){var event=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var idMatchesSlot=event.slot&&_this2.props.gptId===event.slot.getSlotElementId();if(idMatchesSlot&&event.isEmpty&&_this2.props.onError){_this2.props.onError();}});}},{key:"appendCmd",value:function appendCmd(googletag){var _this3=this;googletag.cmd.push(function(){var slot=googletag.defineSlot(_this3.props.slot,_this3.props.sizeMap,_this3.props.gptId).addService(googletag.pubads());if(_this3.props.targets){Object.keys(_this3.props.targets).map(function(key){return slot.setTargeting(key,_this3.props.targets[key]);});}googletag.pubads().enableSingleRequest();googletag.enableServices();_this3.addSlotRenderEndedListener(googletag);});}},{key:"mountAd",value:function mountAd(googletag){var _this4=this;googletag.cmd.push(function(){googletag.display(_this4.props.gptId);});}}]);return GptProcessor;}(react.Component);(0,defineProperty/* default */.Z)(GptProcessor,"propTypes",{slot:(prop_types_default()).string.isRequired,gptId:(prop_types_default()).string.isRequired,sizeMap:(prop_types_default()).array.isRequired,targets:(prop_types_default()).object,onError:(prop_types_default()).func});GptProcessor.displayName='GptProcessor';/* harmony default export */ var esm_GptProcessor = (GptProcessor);
//# sourceMappingURL=GptProcessor.js.map
;// CONCATENATED MODULE: ./node_modules/@pcln/ad-unit/dist/esm/index.js

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 48013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MerchModule_MerchModule; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js
var index_esm = __webpack_require__(99278);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Heading/Heading.js
var Heading = __webpack_require__(97331);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Layout/Layout.js
var Layout = __webpack_require__(88939);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Container/Container.js
var Container = __webpack_require__(32223);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Image/Image.js
var Image = __webpack_require__(38489);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(60136);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(82963);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(61120);
;// CONCATENATED MODULE: ./node_modules/@pcln/react-analytics/dist/esm/AnalyticsOnClick.js
var _excluded=["children","fireOnce","action","category","label","onClick"];function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=(0,getPrototypeOf/* default */.Z)(Derived),result;if(hasNativeReflectConstruct){var NewTarget=(0,getPrototypeOf/* default */.Z)(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return (0,possibleConstructorReturn/* default */.Z)(this,result);};}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}/* eslint-disable no-unused-vars */var propTypes={children:(prop_types_default()).element,/** For overriding default category */category:(prop_types_default()).string,action:(prop_types_default()).string.isRequired,label:(prop_types_default()).string.isRequired,/** Tag will only fire one time if this is true. */fireOnce:(prop_types_default()).bool,onClick:(prop_types_default()).func};var contextTypes={analytics:prop_types_default().shape({logEvent:(prop_types_default()).func,gaCategory:(prop_types_default()).string})};var AnalyticsOnClick=/*#__PURE__*/function(_React$Component){(0,inherits/* default */.Z)(AnalyticsOnClick,_React$Component);var _super=_createSuper(AnalyticsOnClick);function AnalyticsOnClick(props){var _this;(0,classCallCheck/* default */.Z)(this,AnalyticsOnClick);_this=_super.call(this,props);_this.state={tagFired:false};_this.enhancedClick=_this.enhancedClick.bind((0,assertThisInitialized/* default */.Z)(_this));return _this;}(0,createClass/* default */.Z)(AnalyticsOnClick,[{key:"enhancedClick",value:function enhancedClick(event){this.context.analytics.logEvent({category:this.props.category||this.context.analytics.gaCategory,action:this.props.action,label:this.props.label});if(this.props.children.props.onClick){this.props.children.props.onClick(event);}this.setState({tagFired:true});}},{key:"render",value:function render(){var _this$props=this.props,children=_this$props.children,fireOnce=_this$props.fireOnce,action=_this$props.action,category=_this$props.category,label=_this$props.label,onClick=_this$props.onClick,props=(0,objectWithoutProperties/* default */.Z)(_this$props,_excluded);var childElement=this.props.children;if(!this.context.analytics||this.state.tagFired&&fireOnce){return this.props.children;}else{return/*#__PURE__*/react.cloneElement(childElement,(0,objectSpread2/* default */.Z)({onClick:this.enhancedClick},props));}}}]);return AnalyticsOnClick;}(react.Component);AnalyticsOnClick.propTypes=propTypes;AnalyticsOnClick.contextTypes=contextTypes;/* harmony default export */ var esm_AnalyticsOnClick = (AnalyticsOnClick);
//# sourceMappingURL=AnalyticsOnClick.js.map
;// CONCATENATED MODULE: ./node_modules/@pcln/marketing/dist/esm/MerchImage/MerchImage.js
var ResponsiveImage=(0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({displayName:"MerchImage__ResponsiveImage",componentId:"sc-16ti2t2-0"})(["aspect-ratio:",";object-fit:",";display:flex;max-height:250px;min-height:unset;","{min-height:",";max-height:500px;}"],function(props){return props.imageAspectRatio?props.imageAspectRatio:'16/9';},function(props){return props.objectFit?props.objectFit:'contain';},(0,index_esm/* themeGet */.R)('mediaQueries.md'),function(props){return props.minImageHeight?props.minImageHeight:'250px';});var CreateLink=function CreateLink(_ref){var minImageHeight=_ref.minImageHeight,imageUrl=_ref.imageUrl,imageAlt=_ref.imageAlt,callToAction=_ref.callToAction,borderRadius=_ref.borderRadius,imageAspectRatio=_ref.imageAspectRatio,objectFit=_ref.objectFit;return/*#__PURE__*/react.createElement(Link/* default */.Z,{href:callToAction.url,target:callToAction.openInNewTab?'_blank':undefined,rel:callToAction.openInNewTab?'noopener':undefined,"data-testid":"image-link-id"},/*#__PURE__*/react.createElement(ResponsiveImage,{minImageHeight:minImageHeight,objectFit:objectFit,imageAspectRatio:imageAspectRatio,src:imageUrl,alt:imageAlt,borderRadius:borderRadius}));};function MerchImage(_ref2){var minImageHeight=_ref2.minImageHeight,imageUrl=_ref2.imageUrl,imageAlt=_ref2.imageAlt,callToAction=_ref2.callToAction,borderRadius=_ref2.borderRadius,imageAspectRatio=_ref2.imageAspectRatio,objectFit=_ref2.objectFit;var _ref3=(callToAction===null||callToAction===void 0?void 0:callToAction.googleAnalyticsTracking)||{},action=_ref3.action,category=_ref3.category,label=_ref3.label;if(callToAction!==null&&callToAction!==void 0&&callToAction.url&&category&&action&&label){return/*#__PURE__*/react.createElement(esm_AnalyticsOnClick,{action:callToAction.googleAnalyticsTracking.action,label:callToAction.googleAnalyticsTracking.label,category:callToAction.googleAnalyticsTracking.category},/*#__PURE__*/react.createElement(CreateLink,{minImageHeight:minImageHeight,objectFit:objectFit,imageAspectRatio:imageAspectRatio,imageUrl:imageUrl,imageAlt:imageAlt,callToAction:callToAction,borderRadius:borderRadius}));}else if(callToAction!==null&&callToAction!==void 0&&callToAction.url){return/*#__PURE__*/react.createElement(CreateLink,{minImageHeight:minImageHeight,objectFit:objectFit,imageAspectRatio:imageAspectRatio,imageUrl:imageUrl,imageAlt:imageAlt,callToAction:callToAction,borderRadius:borderRadius});}else{return/*#__PURE__*/react.createElement(ResponsiveImage,{minImageHeight:minImageHeight,objectFit:objectFit,imageAspectRatio:imageAspectRatio,src:imageUrl,alt:imageAlt,borderRadius:borderRadius});}}MerchImage.propTypes={minImageHeight:(prop_types_default()).string,imageAlt:(prop_types_default()).string,imageUrl:(prop_types_default()).string,objectFit:prop_types_default().oneOf(['contain','cover']),callToAction:(prop_types_default()).object,borderRadius:(prop_types_default()).string,imageAspectRatio:prop_types_default().oneOf(['1/1','3/2','4/3','16/9'])};CreateLink.propTypes={objectFit:prop_types_default().oneOf(['contain','cover']),imageAlt:(prop_types_default()).string,imageUrl:(prop_types_default()).string,callToAction:(prop_types_default()).object,borderRadius:(prop_types_default()).string,imageAspectRatio:prop_types_default().oneOf(['1/1','3/2','4/3','16/9']),minImageHeight:(prop_types_default()).string};/* harmony default export */ var MerchImage_MerchImage = (MerchImage);
//# sourceMappingURL=MerchImage.js.map
;// CONCATENATED MODULE: ./node_modules/@pcln/marketing/dist/esm/utils/isBackgroundDark.js
function isBackgroundDark(backgroundColor){return backgroundColor.includes('base')&&!backgroundColor.includes('background')||backgroundColor.includes('dark')||backgroundColor.includes('shade')||backgroundColor.includes('tone');}/* harmony default export */ var utils_isBackgroundDark = (isBackgroundDark);
//# sourceMappingURL=isBackgroundDark.js.map
;// CONCATENATED MODULE: ./node_modules/@pcln/marketing/dist/esm/MerchModule/MerchModule.js
var defaultListStyling=(0,styled_components_browser_esm/* css */.iv)(["display:block;padding-left:","px;& li > p{margin:","px 0;}"],(0,index_esm/* themeGet */.R)('space.4'),(0,index_esm/* themeGet */.R)('space.3'));var ModuleWrapper=(0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({displayName:"MerchModule__ModuleWrapper",componentId:"sc-14j1nf9-0"})(["display:flex;max-width:1280px;margin:0 auto;& ul,& ol{display:flex;flex-direction:column;list-style-type:none;padding-left:0;& li > p{margin:","px 0;}","{","}}& ul{list-style-type:",";","{list-style-type:",";}}& ol{","{list-style-type:",";}}"],(0,index_esm/* themeGet */.R)('space.0'),(0,index_esm/* themeGet */.R)('mediaQueries.lg'),function(props){return props.textAlign!=='center'&&defaultListStyling;},function(props){return props.unorderedListStyleType;},(0,index_esm/* themeGet */.R)('mediaQueries.lg'),function(props){return props.textAlign==='center'?'none':'disc';},(0,index_esm/* themeGet */.R)('mediaQueries.lg'),function(props){return props.textAlign==='center'?'none':'decimal';});var ImageWrapper=(0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({displayName:"MerchModule__ImageWrapper",componentId:"sc-14j1nf9-1"})(["display:",";","{display:flex;}","{display:flex;}"],function(props){return props.imageDisplayMobile?'flex':'none';},(0,index_esm/* themeGet */.R)('mediaQueries.lg'),(0,index_esm/* themeGet */.R)('mediaQueries.md'));function MerchModule(_ref){var actions=_ref.actions,backgroundColor=_ref.backgroundColor,body=_ref.body,bodyLineHeight=_ref.bodyLineHeight,boxProps=_ref.boxProps,callToAction=_ref.callToAction,columnVariation=_ref.columnVariation,headingFontSize=_ref.headingFontSize,headingMB=_ref.headingMB,headingTextStyle=_ref.headingTextStyle,headline=_ref.headline,headlineColor=_ref.headlineColor,imageAlt=_ref.imageAlt,imageAspectRatio=_ref.imageAspectRatio,imageDisplayMobile=_ref.imageDisplayMobile,imageUrl=_ref.imageUrl,isBox=_ref.isBox,isMobile=_ref.isMobile,unorderedListStyleType=_ref.unorderedListStyleType,mediaDisplay=_ref.mediaDisplay,mediaPosition=_ref.mediaPosition,minImageHeight=_ref.minImageHeight,tagline=_ref.tagline,taglineColor=_ref.taglineColor,taglineTextStyle=_ref.taglineTextStyle,textAlign=_ref.textAlign;var isDark=utils_isBackgroundDark(backgroundColor);if(isDark){headlineColor='text.lightest';taglineColor='text.lightest';}var wrapperDirection=mediaPosition==='right'?'row-reverse':mediaPosition==='center'?'column-reverse':'row';var wrapperDirectionResponsive=[imageDisplayMobile?'column-reverse':wrapperDirection,null,null,wrapperDirection];var textWrapperAlign=mediaPosition==='center'&&unorderedListStyleType==='none'?'center':unorderedListStyleType==='disc'?'left':['center',null,null,'left'];var _ref2=(body===null||body===void 0?void 0:body.props)||{},color=_ref2.color,fontSize=_ref2.fontSize,textStyle=_ref2.textStyle;var textProps=(0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({color:isDark?'text.lightest':color||'text.light',fontSize:fontSize||[2,null,null,null,3],textAlign:textAlign},bodyLineHeight&&{lineHeight:bodyLineHeight}),textStyle&&{textStyle:textStyle});var MerchBody=function MerchBody(){return/*#__PURE__*/react.createElement(Flex/* default */.Z,{height:"100%",flexDirection:"column",justifyContent:"center",textAlign:textWrapperAlign,"data-testid":"merch-module-text-wrapper"},tagline&&/*#__PURE__*/react.createElement(Text/* default */.ZP,{textAlign:textAlign,fontSize:0,fontWeight:"bold",textTransform:"caps",color:taglineColor,mb:headline&&3,textStyle:taglineTextStyle,"data-testid":"tagline-text"},tagline),/*#__PURE__*/react.createElement(Heading/* default.h3 */.Z.h3,{textAlign:textAlign,fontSize:headingFontSize,textStyle:headingTextStyle,fontWeight:"bold",color:headlineColor,mt:0,mb:headingMB,"data-testid":"header-wrapper"},headline),body&&body.props?/*#__PURE__*/react.cloneElement(body,textProps):/*#__PURE__*/react.createElement(Text/* default */.ZP,(0,esm_extends/* default */.Z)({mb:actions?3:undefined},textProps),body),actions&&/*#__PURE__*/react.createElement(Flex/* default */.Z,{justifyContent:textAlign},actions));};var MerchImageLogic=function MerchImageLogic(){if(imageUrl){return/*#__PURE__*/react.createElement(ImageWrapper,{justifyContent:"center",height:"100%",imageDisplayMobile:imageDisplayMobile,"data-testid":"image-wrapper"},/*#__PURE__*/react.createElement(MerchImage_MerchImage,{minImageHeight:minImageHeight,objectFit:mediaDisplay,imageAspectRatio:imageAspectRatio,imageUrl:imageUrl,imageAlt:imageAlt,callToAction:callToAction,borderRadius:"lg"}));}return null;};var MerchModuleLogic=function MerchModuleLogic(){return/*#__PURE__*/react.createElement(ModuleWrapper,{alignItems:"center",flexDirection:wrapperDirectionResponsive,justifyContent:"space-between",textAlign:textAlign,imageDisplayMobile:imageDisplayMobile,"data-testid":"merch-module-wrapper"},mediaPosition==='right'&&!isMobile?/*#__PURE__*/react.createElement(Layout/* default */.Z,{flexWrap:['wrap-reverse','wrap-reverse',null,null,'wrap'],variation:columnVariation,rowGap:"lg",gap:['lg',null,null,'xl']},/*#__PURE__*/react.createElement(MerchBody,null),/*#__PURE__*/react.createElement(MerchImageLogic,null)):mediaPosition==='center'&&!isMobile?/*#__PURE__*/react.createElement(Layout/* default */.Z,{variation:"100",rowGap:"lg",gap:['lg',null,null,'xl']},/*#__PURE__*/react.createElement(MerchImageLogic,null),/*#__PURE__*/react.createElement(MerchBody,null)):mediaPosition==='left'&&!isMobile?/*#__PURE__*/react.createElement(Layout/* default */.Z,{variation:columnVariation,rowGap:"lg",gap:['lg',null,null,'xl']},/*#__PURE__*/react.createElement(MerchImageLogic,null),/*#__PURE__*/react.createElement(MerchBody,null)):isMobile&&!imageDisplayMobile?/*#__PURE__*/react.createElement(Layout/* default */.Z,{variation:columnVariation,rowGap:"lg",gap:['lg',null,null,'xl']},/*#__PURE__*/react.createElement(MerchBody,null)):/*#__PURE__*/react.createElement(Layout/* default */.Z,{variation:columnVariation,rowGap:"lg",gap:['lg',null,null,'xl']},/*#__PURE__*/react.createElement(MerchImageLogic,null),/*#__PURE__*/react.createElement(MerchBody,null)));};return/*#__PURE__*/react.createElement(Container/* default */.Z,null,isBox?/*#__PURE__*/react.createElement(Box/* default */.Z,(0,esm_extends/* default */.Z)({"data-testid":"merch-module-box",borderRadius:"xl",boxShadowSize:"sm",color:backgroundColor},boxProps),/*#__PURE__*/react.createElement(MerchModuleLogic,null)):/*#__PURE__*/react.createElement(Container/* default */.Z,{"data-testid":"merch-module-container",color:backgroundColor},/*#__PURE__*/react.createElement(MerchModuleLogic,null)));}MerchModule.propTypes={actions:(prop_types_default()).node,backgroundColor:(prop_types_default()).string,body:(prop_types_default()).node,bodyLineHeight:(prop_types_default()).string,boxProps:(prop_types_default()).object,callToAction:(prop_types_default()).object,columnVariation:prop_types_default().oneOfType([(prop_types_default()).string,(prop_types_default()).array]),headingFontSize:prop_types_default().oneOfType([(prop_types_default()).string,(prop_types_default()).number,(prop_types_default()).array]),headingMB:prop_types_default().oneOfType([(prop_types_default()).string,(prop_types_default()).number]),headingTextStyle:(prop_types_default()).string,headline:(prop_types_default()).string.isRequired,headlineColor:(prop_types_default()).string,imageAlt:(prop_types_default()).string,imageAspectRatio:prop_types_default().oneOfType([(prop_types_default()).string,(prop_types_default()).array]),imageDisplayMobile:(prop_types_default()).bool,imageUrl:(prop_types_default()).string,isBox:(prop_types_default()).bool,mediaDisplay:prop_types_default().oneOfType([(prop_types_default()).string,(prop_types_default()).array]),mediaPosition:prop_types_default().oneOfType([(prop_types_default()).string,(prop_types_default()).array]),minImageHeight:(prop_types_default()).string,isMobile:(prop_types_default()).bool,unorderedListStyleType:(prop_types_default()).string,tagline:(prop_types_default()).string,taglineColor:(prop_types_default()).string,taglineTextStyle:(prop_types_default()).string,textAlign:prop_types_default().oneOf(['left','center','right'])};MerchModule.defaultProps={backgroundColor:'background.light',columnVariation:['100',null,'50-50'],headingFontSize:[4,null,null,null,5],headingMB:3,headlineColor:'text.base',imageAspectRatio:'16/9',imageDisplayMobile:false,isBox:true,isMobile:false,mediaDisplay:'contain',mediaPosition:'right',minImageHeight:'250px',boxProps:{p:'4'},taglineColor:'text.light',taglineTextStyle:'overline',textAlign:'left',unorderedListStyleType:'none'};/* harmony default export */ var MerchModule_MerchModule = (MerchModule);
//# sourceMappingURL=MerchModule.js.map

/***/ }),

/***/ 97404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AdBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88939);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92833);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32223);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92591);



function AdBanner(param) {
    var children = param.children, _isUsingNewLayout = param.isUsingNewLayout, isUsingNewLayout = _isUsingNewLayout === void 0 ? false : _isUsingNewLayout;
    return isUsingNewLayout ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        variation: "100",
        rowGap: "xl",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                maxWidth: 728,
                children: children
            })
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        py: 4,
        m: "auto",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            maxWidth: 728,
            children: children
        })
    });
}


/***/ }),

/***/ 18194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ AdBox; },
  "j": function() { return /* binding */ AdContent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Layout/Layout.js
var Layout = __webpack_require__(88939);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(37138);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
;// CONCATENATED MODULE: ./src/components/AdContent/AdBox.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n  height: 250px;\n  width: 100%;\n  margin: 0 16px 0 0;\n  max-width: 474px;\n  min-width: 300px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  ",
        " {\n    display: block;\n    justify-content: center;\n    height: 250px;\n    width: 100%;\n    margin: 0 16px 0 0;\n    max-width: 474px;\n    min-width: 300px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 250px;\n  width: 300px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var PrimaryWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-63e842b6-0"
})(_templateObject());
var SecondaryWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-63e842b6-1"
})(_templateObject1(), (0,index_esm/* themeGet */.R)("mediaQueries.xl"));
var TertiaryWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-63e842b6-2"
})(_templateObject2());
var AdBoxWrapper = {
    primary: PrimaryWrapper,
    secondary: SecondaryWrapper,
    tertiary: TertiaryWrapper
};
function AdBox(param) {
    var children = param.children, type = param.type;
    var Wrapper = AdBoxWrapper[type];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            width: 1,
            children: children
        })
    });
}

;// CONCATENATED MODULE: ./src/components/AdContent/index.tsx




function AdContent(param) {
    var children = param.children, _isUsingNewLayout = param.isUsingNewLayout, isUsingNewLayout = _isUsingNewLayout === void 0 ? false : _isUsingNewLayout;
    return isUsingNewLayout ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        variation: "100",
        rowGap: "xl",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
            alignItems: "center",
            justifyContent: "center",
            children: children
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "center",
        m: 4,
        children: children
    });
}



/***/ }),

/***/ 73895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88939);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92591);
/* harmony import */ var _pcln_vip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90370);
/* harmony import */ var _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94738);







var AppDownloadWrapper = function(_param) {
    var category = _param.category, _isUsingNewLayout = _param.isUsingNewLayout, isUsingNewLayout = _isUsingNewLayout === void 0 ? false : _isUsingNewLayout, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "category",
        "isUsingNewLayout"
    ]);
    var gaAppDownload = function(device) {
        _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
            action: "app download",
            category: category,
            label: device
        });
    };
    return isUsingNewLayout ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        variation: "100",
        rowGap: "xl",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            color: "background.light",
            boxShadowSize: "sm",
            borderRadius: "xl",
            pr: [
                3,
                null,
                null,
                null,
                4,
                5
            ],
            pl: 4,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pcln_vip__WEBPACK_IMPORTED_MODULE_6__/* .AppDownload */ .B, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                gaTracking: gaAppDownload
            }, props))
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pcln_vip__WEBPACK_IMPORTED_MODULE_6__/* .AppDownload */ .B, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        gaTracking: gaAppDownload
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (AppDownloadWrapper);


/***/ }),

/***/ 51730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87379);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23493);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92591);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7981);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70564);
/* harmony import */ var _pcln_ad_unit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6824);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  overflow: hidden;\n  pointer-events: none;\n  position: ",
        ";\n  left: 0;\n  top: 0;\n  z-index: -1;\n\n  & iframe {\n    height: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  z-index: -2;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var BackgroundWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-865b7cee-0"
})(_templateObject(), function(props) {
    return props.isScrollable ? "absolute" : "fixed";
}, function(props) {
    return props.height;
});
var StyledAbsolute = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-865b7cee-1"
})(_templateObject1());
function HeroImageParallax(_param) {
    var children = _param.children, gptId = _param.gptId, slot = _param.slot, _isScrollable = _param.isScrollable, isScrollable = _isScrollable === void 0 ? false : _isScrollable, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "children",
        "gptId",
        "slot",
        "isScrollable"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), height = ref[0], setHeight = ref[1];
    var currentContaineNodeRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var calculateHeight = function() {
            var ref, ref1;
            var headerHeight = ((ref = document.getElementById("exp-hdr")) === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0;
            var heroContainerHeight = (currentContaineNodeRef === null || currentContaineNodeRef === void 0 ? void 0 : (ref1 = currentContaineNodeRef.current) === null || ref1 === void 0 ? void 0 : ref1.offsetHeight) || 0;
            return headerHeight + heroContainerHeight;
        };
        var setHeightThrottled = lodash_throttle__WEBPACK_IMPORTED_MODULE_3___default()(function() {
            setHeight(calculateHeight());
        }, 100);
        if (currentContaineNodeRef && currentContaineNodeRef.current) {
            window.addEventListener("resize", setHeightThrottled);
            var heroContainer = currentContaineNodeRef.current;
            var config = {
                attributes: true,
                childList: true,
                subtree: true
            };
            var observer = new MutationObserver(setHeightThrottled);
            observer.observe(heroContainer, config);
            return function() {
                window.removeEventListener("resize", setHeightThrottled);
                observer.disconnect();
            };
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        ref: currentContaineNodeRef
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledAbsolute, {
                color: "primary.dark"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BackgroundWrapper, {
                width: 1,
                height: height,
                isScrollable: isScrollable,
                className: "HeroImageParallax",
                "data-testid": "hero-image-parallax",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pcln_ad_unit__WEBPACK_IMPORTED_MODULE_4__/* .Gpt */ .B, {
                    render: function() {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pcln_ad_unit__WEBPACK_IMPORTED_MODULE_4__/* .GptProcessor */ .o, {
                            slot: slot,
                            gptId: gptId,
                            sizeMap: [
                                "fluid"
                            ]
                        });
                    }
                })
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (HeroImageParallax);


/***/ }),

/***/ 81987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_StyledHeading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29293);
/* harmony import */ var _hooks_useCityNameInFormHeadlineForSEM__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40813);
/* harmony import */ var _hooks_useContentfulSearchFormHeadlines__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98673);
/* harmony import */ var _hooks_useSEMSearchHeadline__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32881);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69722);







var FormHeadline = function(param) {
    var location = param.location;
    var searchForm = (0,_hooks_useContentfulSearchFormHeadlines__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("searchForm");
    var prePopHeadline = (0,_hooks_useCityNameInFormHeadlineForSEM__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(location);
    var SEMHeadline = (0,_hooks_useSEMSearchHeadline__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var ref;
    var headline = (ref = prePopHeadline !== null && prePopHeadline !== void 0 ? prePopHeadline : SEMHeadline) !== null && ref !== void 0 ? ref : (searchForm === null || searchForm === void 0 ? void 0 : searchForm.headline) || _constants__WEBPACK_IMPORTED_MODULE_6__/* .PRIMARY_HEADING_FALLBACK */ .kt;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StyledHeading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        tag: "h1",
        color: "text.heading",
        textStyle: [
            "heading3",
            null,
            null,
            null,
            "heading2"
        ],
        text: headline
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormHeadline);


/***/ }),

/***/ 61687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Hotels_HotelsDesktop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/theme/theme.js + 1 modules
var theme = __webpack_require__(15072);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Hide/Hide.js
var Hide = __webpack_require__(87709);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Container/Container.js
var Container = __webpack_require__(32223);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/@pcln/ad-unit/dist/esm/index.js + 3 modules
var esm = __webpack_require__(6824);
// EXTERNAL MODULE: ./src/components/StyledHeading/index.tsx
var StyledHeading = __webpack_require__(29293);
// EXTERNAL MODULE: ./src/components/Heros/HeroImageParallax.tsx
var HeroImageParallax = __webpack_require__(51730);
// EXTERNAL MODULE: ./src/hooks/useExpressDealModal.ts
var useExpressDealModal = __webpack_require__(77185);
// EXTERNAL MODULE: ./src/hooks/useContentfulSearchFormHeadlines.ts
var useContentfulSearchFormHeadlines = __webpack_require__(98673);
// EXTERNAL MODULE: ./src/context/SearchFormContext.tsx
var SearchFormContext = __webpack_require__(51069);
// EXTERNAL MODULE: ./src/hooks/useSeti.ts
var useSeti = __webpack_require__(39939);
// EXTERNAL MODULE: ./src/components/Hotels/ExpressDeal/ExpressDealModal.tsx
var ExpressDealModal = __webpack_require__(55173);
// EXTERNAL MODULE: ./node_modules/@pcln/contentful-components/lib-esm/useContentful/useContentful.js
var useContentful = __webpack_require__(61388);
// EXTERNAL MODULE: ./src/components/AdBanner.tsx
var AdBanner = __webpack_require__(97404);
// EXTERNAL MODULE: ./src/components/AdContent/index.tsx + 1 modules
var AdContent = __webpack_require__(18194);
// EXTERNAL MODULE: ./src/components/AppDownloadWrapper/index.tsx
var AppDownloadWrapper = __webpack_require__(73895);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Layout/Layout.js
var Layout = __webpack_require__(88939);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
;// CONCATENATED MODULE: ./src/components/SEOLinks.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  flex-basis: 340px;\n  flex-shrink: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var LinkFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-88b789a2-0"
})(_templateObject());
function SEOLinks(param) {
    var caption = param.caption, category = param.category, gaAction = param.gaAction, links = param.links;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        variation: "100",
        rowGap: "xl",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    fontSize: 3,
                    fontWeight: "bold",
                    mb: 3,
                    textAlign: "left",
                    children: caption
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    flexWrap: "wrap",
                    children: links.map(function(link, index) {
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(LinkFlex, {
                            children: ((ref = link.href) === null || ref === void 0 ? void 0 : ref.length) > 0 && ((ref1 = link.text) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: link.href,
                                onClick: function() {
                                    analytics/* default.fireEvent */.Z.fireEvent({
                                        action: gaAction,
                                        category: category,
                                        label: link.text
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    fontSize: 1,
                                    mb: 2,
                                    children: link.text
                                })
                            }) : null
                        }, "SEO-Flex-".concat(index + 1));
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/components/EmailSignUp/index.tsx + 7 modules
var EmailSignUp = __webpack_require__(86229);
// EXTERNAL MODULE: ./src/constants/analytics.ts
var constants_analytics = __webpack_require__(66487);
;// CONCATENATED MODULE: ./src/constants/seo-product-links.ts
/* harmony default export */ var seo_product_links = ({
    HOTELS: {
        name: "HOTEL",
        links: {
            exploreDeals: {
                USA: {
                    caption: "Top Hotel Deals in the United States",
                    section: 1,
                    action: "Cheap Hotels",
                    items: [
                        {
                            href: "/hotel-deals/c3000001438/US/California/Anaheim-Hotels.html",
                            text: "Anaheim Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000020845/US/Texas/Arlington-Hotels.html",
                            text: "Arlington Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000003496/US/Georgia/Atlanta-Hotels.html",
                            text: "Atlanta Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000020856/US/Texas/Austin-Hotels.html",
                            text: "Austin Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000008602/US/Massachusetts/Boston-Hotels.html",
                            text: "Boston Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000012874/US/North-Carolina/Charlotte-Hotels.html",
                            text: "Charlotte Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000005381/US/Illinois/Chicago-Hotels.html",
                            text: "Chicago Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000016809/US/Ohio/Columbus-Hotels.html",
                            text: "Columbus Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000021082/US/Texas/Dallas-Hotels.html",
                            text: "Dallas Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000002573/US/Colorado/Denver-Hotels.html",
                            text: "Denver Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000021312/US/Texas/Houston-Hotels.html",
                            text: "Houston Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000006556/US/Indiana/Indianapolis-Hotels.html",
                            text: "Indianapolis Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000003249/US/Florida/Jacksonville-Hotels.html",
                            text: "Jacksonville Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000015284/US/Nevada/Las-Vegas-Hotels.html",
                            text: "Las Vegas Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000001947/US/California/Los-Angeles-Hotels.html",
                            text: "Los Angeles Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000003311/US/Florida/Miami-Hotels.html",
                            text: "Miami Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000020633/US/Tennessee/Nashville-Hotels.html",
                            text: "Nashville Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000008434/US/Louisiana/New-Orleans-Hotels.html",
                            text: "New Orleans Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000016152/US/New-York/New-York-Hotels.html",
                            text: "New York Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000003349/US/Florida/Orlando-Hotels.html",
                            text: "Orlando Hotels"
                        },
                        {
                            href: "/hotel-deals/r46/US/Pennsylvania-Hotels.html",
                            text: "Philadelphia Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000001349/US/Arizona/Phoenix-Hotels.html",
                            text: "Phoenix Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000018178/US/Oregon/Portland-Hotels.html",
                            text: "Portland Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000011975/US/Missouri/Saint-Louis-Hotels.html",
                            text: "Saint Louis Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000021763/US/Texas/San-Antonio-Hotels.html",
                            text: "San Antonio Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000002241/US/California/San-Diego-Hotels.html",
                            text: "San Diego Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000002244/US/California/San-Francisco-Hotels.html",
                            text: "San Francisco Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000023414/US/Washington/Seattle-Hotels.html",
                            text: "Seattle Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000003431/US/Florida/Tampa-Hotels.html",
                            text: "Tampa Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000003032/US/District-Of-Columbia/Washington-Hotels.html",
                            text: "Washington Hotels"
                        }
                    ]
                },
                EUROPE: {
                    caption: "Top Hotel Deals in Europe",
                    section: 2,
                    action: "Cheap Hotels",
                    items: [
                        {
                            href: "/hotel-deals/c3000035824/NL/Noord-Holland/Amsterdam-Hotels.html",
                            text: "Amsterdam Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000035889/GR/Greece/Athens-Hotels.html",
                            text: "Athens Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000035833/SP/Catalu-a/Barcelona-Hotels.html",
                            text: "Barcelona Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000035821/GM/Berlin/Berlin-Hotels.html",
                            text: "Berlin Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000035826/EI/Ireland/Dublin-Hotels.html",
                            text: "Dublin Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000035830/UK/City-Of-Edinburgh-Scotland/Edinburgh-Hotels.html",
                            text: "Edinburgh Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000035879/IT/Toscana-Tuscany-/Florence-Hotels.html",
                            text: "Florence Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000035831/GM/Hessen/Frankfurt-Hotels.html",
                            text: "Frankfurt Hotels"
                        },
                        {
                            href: "/hotel-deals/c5000436138/GB/England/Hillingdon-Hotels.html",
                            text: "Hillingdon Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000035890/PO/Portugal/Lisbon-Hotels.html",
                            text: "Lisbon Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000035825/UK/England/London-Hotels.html",
                            text: "London Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000035834/SP/Comunidad-De-Madrid/Madrid-Hotels.html",
                            text: "Madrid Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000035829/IT/Lombardia/Milan-Hotels.html",
                            text: "Milan Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000035919/GM/Bayern/Munich-Hotels.html",
                            text: "Munich Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000035827/FR/Paris/Paris-Hotels.html",
                            text: "Paris Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000035883/CZ/Stredocesky/Prague-Hotels.html",
                            text: "Prague Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000035839/FR/Val-Doise/Roissy-Hotels.html",
                            text: "Roissy Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000035823/IT/Lazio/Rome-Hotels.html",
                            text: "Rome Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000035822/IT/Veneto/Venice-Hotels.html",
                            text: "Venice Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000035894/SZ/Zurich/Zurich-Hotels.html",
                            text: "Zurich Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000035886/AT/Wien/Vienna-Hotels.html",
                            text: "Vienna Hotels"
                        }
                    ]
                },
                ASIA: {
                    caption: "Top Hotel Deals in Asia",
                    section: 3,
                    action: "Cheap Hotels",
                    items: [
                        {
                            href: "/hotel-deals/c3000040033/TH/Krung-Thep-Mahanakhon/Bangkok-Hotels.html",
                            text: "Bangkok Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000040013/CH/Beijing/Beijing-Hotels.html",
                            text: "Beijing Hotels"
                        },
                        {
                            href: "/hotel-deals/c5000490977/TH/Chiang-Mai/Chiang-Mai-Hotels.html",
                            text: "Chiang Mai Hotels"
                        },
                        {
                            href: "/hotel-deals/c5000003658/TC/Dubayy/Dubai-Hotels.html",
                            text: "Dubai Hotels"
                        },
                        {
                            href: "/hotel-deals/c5000466043/VM/Ho-Chi-Minh/Ho-Chi-Minh-City-Hotels.html",
                            text: "Ho Chi Minh City Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000040012/HK/Hong-Kong-Sar/Hong-Kong-Hotels.html",
                            text: "Hong Kong Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000040045/TU/Istanbul/Istanbul-Hotels.html",
                            text: "Istanbul Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000040026/ID/Jakarta-Raya/Jakarta-Hotels.html",
                            text: "Jakarta Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000040022/MY/Wilayah-Persekutuan-Kuala-Lumpur/Kuala-Lumpur-Hotels.html",
                            text: "Kuala Lumpur Hotels"
                        },
                        {
                            href: "/hotel-deals/c5000479776/JA/Kyoto/Kyoto-Hotels.html",
                            text: "Kyoto Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000040031/RP/Metro-Manila/Manila-Hotels.html",
                            text: "Manila Hotels"
                        },
                        {
                            href: "/hotel-deals/c5000494939/IN/Maharashtra/Mumbai-Hotels.html",
                            text: "Mumbai Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000040029/IN/Delhi/New-Delhi-Hotels.html",
                            text: "New Delhi Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000040036/JA/Osaka/Osaka-Hotels.html",
                            text: "Osaka Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000040034/TH/Phuket/Phuket-Hotels.html",
                            text: "Phuket Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000040019/KS/Seoul/Seoul-Hotels.html",
                            text: "Seoul Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000040015/CH/Shanghai/Shanghai-Hotels.html",
                            text: "Shanghai Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000040021/SN/Singapore/Singapore-Hotels.html",
                            text: "Singapore Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000040018/TW/T-ai-Pei-Chuen-Shih/Taipei-Hotels.html",
                            text: "Taipei Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000040035/JA/Tokyo/Tokyo-Hotels.html",
                            text: "Tokyo Hotels"
                        },
                        {
                            href: "",
                            text: ""
                        }
                    ]
                },
                INTERNATIONAL: {
                    caption: "Top International Hotel Deals",
                    section: 4,
                    action: "Cheap Hotels",
                    items: [
                        {
                            href: "/hotel-deals/c3000031041/CA/Alberta/Banff-Hotels.html",
                            text: "Banff Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000031085/CA/Alberta/Calgary-Hotels.html",
                            text: "Calgary Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000061781/MX/Quintana-Roo/Cancun-Hotels.html",
                            text: "Cancun Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000031161/CA/Alberta/Edmonton-Hotels.html",
                            text: "Edmonton Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000035653/CA/Nova-Scotia/Halifax-Hotels.html",
                            text: "Halifax Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000033081/CA/Ontario/London-Hotels.html",
                            text: "London Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000033109/CA/Ontario/Markham-Hotels.html",
                            text: "Markham Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000040001/AS/Victoria/Melbourne-Hotels.html",
                            text: "Melbourne Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000033144/CA/Ontario/Mississauga-Hotels.html",
                            text: "Mississauga Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000033184/CA/Ontario/Niagara-Falls-Hotels.html",
                            text: "Niagara Falls Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000033237/CA/Ontario/Ottawa-Hotels.html",
                            text: "Ottawa Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000030161/CA/Quebec/Quebec-City-Hotels.html",
                            text: "Quebec City Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000030844/CA/British-Columbia/Richmond-Hotels.html",
                            text: "Richmond Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000032216/CA/Saskatchewan/Saskatoon-Hotels.html",
                            text: "Saskatoon Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000040000/AS/New-South-Wales/Sydney-Hotels.html",
                            text: "Sydney Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000033452/CA/Ontario/Toronto-Hotels.html",
                            text: "Toronto Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000030999/CA/British-Columbia/Vancouver-Hotels.html",
                            text: "Vancouver Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000031000/CA/British-Columbia/Victoria-Hotels.html",
                            text: "Victoria Hotels"
                        },
                        {
                            href: "/hotel-deals/c3000032664/CA/Manitoba/Winnipeg-Hotels.html",
                            text: "Winnipeg Hotels"
                        }
                    ]
                },
                GLOBAL: {
                    caption: "Top Global Hotel Deals",
                    section: 5,
                    action: "Cheap Hotels",
                    items: [
                        {
                            href: "/hotel-deals/k218/Albania-Hotels.html",
                            text: "Albania Hotels"
                        },
                        {
                            href: "/hotel-deals/k54/Algeria-Hotels.html",
                            text: "Algeria Hotels"
                        },
                        {
                            href: "/hotel-deals/k170/Andorra-Hotels.html",
                            text: "Andorra Hotels"
                        },
                        {
                            href: "/hotel-deals/k192/Anguilla-Hotels.html",
                            text: "Anguilla Hotels"
                        },
                        {
                            href: "/hotel-deals/k186/Antigua-and-Barbuda-Hotels.html",
                            text: "Antigua and Barbuda Hotels"
                        },
                        {
                            href: "/hotel-deals/k124/Argentina-Hotels.html",
                            text: "Argentina Hotels"
                        },
                        {
                            href: "/hotel-deals/k130/Armenia-Hotels.html",
                            text: "Armenia Hotels"
                        },
                        {
                            href: "/hotel-deals/k236/Aruba-Hotels.html",
                            text: "Aruba Hotels"
                        },
                        {
                            href: "/hotel-deals/k3/Australia-Hotels.html",
                            text: "Australia Hotels"
                        },
                        {
                            href: "/hotel-deals/k11/Austria-Hotels.html",
                            text: "Austria Hotels"
                        },
                        {
                            href: "/hotel-deals/k210/Azerbaijan-Hotels.html",
                            text: "Azerbaijan Hotels"
                        },
                        {
                            href: "/hotel-deals/k13/Bahamas-Hotels.html",
                            text: "Bahamas Hotels"
                        },
                        {
                            href: "/hotel-deals/k68/Bahrain-Hotels.html",
                            text: "Bahrain Hotels"
                        },
                        {
                            href: "/hotel-deals/k74/Bangladesh-Hotels.html",
                            text: "Bangladesh Hotels"
                        },
                        {
                            href: "/hotel-deals/k144/Barbados-Hotels.html",
                            text: "Barbados Hotels"
                        },
                        {
                            href: "/hotel-deals/k121/Belarus-Hotels.html",
                            text: "Belarus Hotels"
                        },
                        {
                            href: "/hotel-deals/k7/Belgium-Hotels.html",
                            text: "Belgium Hotels"
                        },
                        {
                            href: "/hotel-deals/k102/Belize-Hotels.html",
                            text: "Belize Hotels"
                        },
                        {
                            href: "/hotel-deals/k194/Bermuda-Hotels.html",
                            text: "Bermuda Hotels"
                        },
                        {
                            href: "/hotel-deals/k132/Bolivia-Hotels.html",
                            text: "Bolivia Hotels"
                        },
                        {
                            href: "/hotel-deals/k185/Bonaire-Sint-Eustatius-and-Saba-Hotels.html",
                            text: "Bonaire, Sint Eustatius and Saba Hotels"
                        },
                        {
                            href: "/hotel-deals/k223/Bosnia-and-Herzegovina-Hotels.html",
                            text: "Bosnia and Herzegovina Hotels"
                        },
                        {
                            href: "/hotel-deals/k140/Botswana-Hotels.html",
                            text: "Botswana Hotels"
                        },
                        {
                            href: "/hotel-deals/k115/Brazil-Hotels.html",
                            text: "Brazil Hotels"
                        },
                        {
                            href: "/hotel-deals/k193/British-Virgin-Islands-Hotels.html",
                            text: "British Virgin Islands Hotels"
                        },
                        {
                            href: "/hotel-deals/k106/Brunei-Hotels.html",
                            text: "Brunei Hotels"
                        },
                        {
                            href: "/hotel-deals/k213/Bulgaria-Hotels.html",
                            text: "Bulgaria Hotels"
                        },
                        {
                            href: "/hotel-deals/k164/Cambodia-Hotels.html",
                            text: "Cambodia Hotels"
                        },
                        {
                            href: "/hotel-deals/k39/Cameroon-Hotels.html",
                            text: "Cameroon Hotels"
                        },
                        {
                            href: "/hotel-deals/k2/Canada-Hotels.html",
                            text: "Canada Hotels"
                        },
                        {
                            href: "/hotel-deals/k226/Cayman-Islands-Hotels.html",
                            text: "Cayman Islands Hotels"
                        },
                        {
                            href: "/hotel-deals/k114/Chile-Hotels.html",
                            text: "Chile Hotels"
                        },
                        {
                            href: "/hotel-deals/k18/China-Hotels.html",
                            text: "China Hotels"
                        },
                        {
                            href: "/hotel-deals/k42/Colombia-Hotels.html",
                            text: "Colombia Hotels"
                        },
                        {
                            href: "/hotel-deals/k137/Congo-Hotels.html",
                            text: "Congo Hotels"
                        },
                        {
                            href: "/hotel-deals/k198/Cook-Islands-Hotels.html",
                            text: "Cook Islands Hotels"
                        },
                        {
                            href: "/hotel-deals/k43/Costa-Rica-Hotels.html",
                            text: "Costa Rica Hotels"
                        },
                        {
                            href: "/hotel-deals/k146/Croatia-Hotels.html",
                            text: "Croatia Hotels"
                        },
                        {
                            href: "/hotel-deals/k184/Curacao-Hotels.html",
                            text: "Curacao Hotels"
                        },
                        {
                            href: "/hotel-deals/k84/Cyprus-Hotels.html",
                            text: "Cyprus Hotels"
                        },
                        {
                            href: "/hotel-deals/k117/Czech-Republic-Hotels.html",
                            text: "Czech Republic Hotels"
                        },
                        {
                            href: "/hotel-deals/k16/Denmark-Hotels.html",
                            text: "Denmark Hotels"
                        },
                        {
                            href: "/hotel-deals/k100/Djibouti-Hotels.html",
                            text: "Djibouti Hotels"
                        },
                        {
                            href: "/hotel-deals/k29/Dominican-Republic-Hotels.html",
                            text: "Dominican Repubic Hotels"
                        },
                        {
                            href: "/hotel-deals/k44/Ecuador-Hotels.html",
                            text: "Ecuador Hotels"
                        },
                        {
                            href: "/hotel-deals/k47/Egypt-Hotels.html",
                            text: "Egypt Hotels"
                        },
                        {
                            href: "/hotel-deals/k82/El-Salvador-Hotels.html",
                            text: "El Salvador Hotels"
                        },
                        {
                            href: "/hotel-deals/k219/Estonia-Hotels.html",
                            text: "Estonia Hotels"
                        },
                        {
                            href: "/hotel-deals/k50/Ethiopia-Hotels.html",
                            text: "Ethiopia Hotels"
                        },
                        {
                            href: "/hotel-deals/k143/Faroe-Islands-Hotels.html",
                            text: "Faroe Islands Hotels"
                        },
                        {
                            href: "/hotel-deals/k178/Fiji-Hotels.html",
                            text: "Fiji Hotels"
                        },
                        {
                            href: "/hotel-deals/k31/Finland-Hotels.html",
                            text: "Finland Hotels"
                        },
                        {
                            href: "/hotel-deals/k9/France-Hotels.html",
                            text: "France Hotels"
                        },
                        {
                            href: "/hotel-deals/k149/French-Guiana-Hotels.html",
                            text: "French Guiana Hotels"
                        },
                        {
                            href: "/hotel-deals/k197/French-Polynesia-Hotels.html",
                            text: "French Polynesia Hotels"
                        },
                        {
                            href: "/hotel-deals/k127/Gabon-Hotels.html",
                            text: "Gabon Hotels"
                        },
                        {
                            href: "/hotel-deals/k157/Gambia-Hotels.html",
                            text: "Gambia Hotels"
                        },
                        {
                            href: "/hotel-deals/k109/Georgia-Hotels.html",
                            text: "Georgia Hotels"
                        },
                        {
                            href: "/hotel-deals/k4/Germany-Hotels.html",
                            text: "Germany Hotels"
                        },
                        {
                            href: "/hotel-deals/k126/Ghana-Hotels.html",
                            text: "Ghana Hotels"
                        },
                        {
                            href: "/hotel-deals/k232/Gibraltar-Hotels.html",
                            text: "Gibraltar Hotels"
                        },
                        {
                            href: "/hotel-deals/k61/Greece-Hotels.html",
                            text: "Greece Hotels"
                        },
                        {
                            href: "/hotel-deals/k123/Greenland-Hotels.html",
                            text: "Greenland Hotels"
                        },
                        {
                            href: "/hotel-deals/k90/Grenada-Hotels.html",
                            text: "Grenada Hotels"
                        },
                        {
                            href: "/hotel-deals/k187/Guadeloupe-Hotels.html",
                            text: "Guadeloupe Hotels"
                        },
                        {
                            href: "/hotel-deals/k76/Guatemala-Hotels.html",
                            text: "Guatemala Hotels"
                        },
                        {
                            href: "/hotel-deals/k35/Guyana-Hotels.html",
                            text: "Guyana Hotels"
                        },
                        {
                            href: "/hotel-deals/k103/Haiti-Hotels.html",
                            text: "Haiti Hotels"
                        },
                        {
                            href: "/hotel-deals/k78/Honduras-Hotels.html",
                            text: "Honduras Hotels"
                        },
                        {
                            href: "/hotel-deals/k17/Hong-Kong-Hotels.html",
                            text: "Hong Kong Hotels"
                        },
                        {
                            href: "/hotel-deals/k15/Hungary-Hotels.html",
                            text: "Hungary Hotels"
                        },
                        {
                            href: "/hotel-deals/k112/Iceland-Hotels.html",
                            text: "Iceland Hotels"
                        },
                        {
                            href: "/hotel-deals/k73/India-Hotels.html",
                            text: "India Hotels"
                        },
                        {
                            href: "/hotel-deals/k23/Indonesia-Hotels.html",
                            text: "Indonesia Hotels"
                        },
                        {
                            href: "/hotel-deals/k182/Ireland-Hotels.html",
                            text: "Ireland Hotels"
                        },
                        {
                            href: "/hotel-deals/k62/Israel-Hotels.html",
                            text: "Israel Hotels"
                        },
                        {
                            href: "/hotel-deals/k5/Italy-Hotels.html",
                            text: "Italy Hotels"
                        },
                        {
                            href: "/hotel-deals/k129/Ivory-Coast-Hotels.html",
                            text: "Ivory Coast Hotels"
                        },
                        {
                            href: "/hotel-deals/k30/Jamaica-Hotels.html",
                            text: "Jamaica Hotels"
                        },
                        {
                            href: "/hotel-deals/k27/Japan-Hotels.html",
                            text: "Japan Hotels"
                        },
                        {
                            href: "/hotel-deals/k208/Jordan-Hotels.html",
                            text: "Jordan Hotels"
                        },
                        {
                            href: "/hotel-deals/k110/Kazakhstan-Hotels.html",
                            text: "Kazakhstan Hotels"
                        },
                        {
                            href: "/hotel-deals/k125/Kenya-Hotels.html",
                            text: "Kenya Hotels"
                        },
                        {
                            href: "/hotel-deals/k118/Kosovo-Hotels.html",
                            text: "Kosovo Hotels"
                        },
                        {
                            href: "/hotel-deals/k66/Kuwait-Hotels.html",
                            text: "Kuwait Hotels"
                        },
                        {
                            href: "/hotel-deals/k111/Kyrgyzstan-Hotels.html",
                            text: "Kyrgyzstan Hotels"
                        },
                        {
                            href: "/hotel-deals/k107/Laos-Hotels.html",
                            text: "Laos Hotels"
                        },
                        {
                            href: "/hotel-deals/k175/Latvia-Hotels.html",
                            text: "Latvia Hotels"
                        },
                        {
                            href: "/hotel-deals/k86/Lebanon-Hotels.html",
                            text: "Lebanon Hotels"
                        },
                        {
                            href: "/hotel-deals/k158/Lesotho-Hotels.html",
                            text: "Lesotho Hotels"
                        },
                        {
                            href: "/hotel-deals/k57/Libya-Hotels.html",
                            text: "Libya Hotels"
                        },
                        {
                            href: "/hotel-deals/k169/Liechtenstein-Hotels.html",
                            text: "Liechtenstein Hotels"
                        },
                        {
                            href: "/hotel-deals/k220/Lithuania-Hotels.html",
                            text: "Lithuania Hotels"
                        },
                        {
                            href: "/hotel-deals/k173/Luxembourg-Hotels.html",
                            text: "Luxembourg Hotels"
                        },
                        {
                            href: "/hotel-deals/k19/Macau-Hotels.html",
                            text: "Macau Hotels"
                        },
                        {
                            href: "/hotel-deals/k224/Macedonia-Hotels.html",
                            text: "Macedonia Hotels"
                        },
                        {
                            href: "/hotel-deals/k163/Madagascar-Hotels.html",
                            text: "Madagascar Hotels"
                        },
                        {
                            href: "/hotel-deals/k160/Malawi-Hotels.html",
                            text: "Malawi Hotels"
                        },
                        {
                            href: "/hotel-deals/k22/Malaysia-Hotels.html",
                            text: "Malaysia Hotels"
                        },
                        {
                            href: "/hotel-deals/k148/Maldives-Hotels.html",
                            text: "Maldives Hotels"
                        },
                        {
                            href: "/hotel-deals/k52/Mali-Hotels.html",
                            text: "Mali Hotels"
                        },
                        {
                            href: "/hotel-deals/k221/Malta-Hotels.html",
                            text: "Malta Hotels"
                        },
                        {
                            href: "/hotel-deals/k190/Martinique-Hotels.html",
                            text: "Martinique Hotels"
                        },
                        {
                            href: "/hotel-deals/k77/Mauritius-Hotels.html",
                            text: "Mauritius Hotels"
                        },
                        {
                            href: "/hotel-deals/k12/Mexico-Hotels.html",
                            text: "Mexico Hotels"
                        },
                        {
                            href: "/hotel-deals/k216/Moldova-Hotels.html",
                            text: "Moldova Hotels"
                        },
                        {
                            href: "/hotel-deals/k233/Monaco-Hotels.html",
                            text: "Monaco Hotels"
                        },
                        {
                            href: "/hotel-deals/k142/Montenegro-Hotels.html",
                            text: "Montenegro Hotels"
                        },
                        {
                            href: "/hotel-deals/k58/Morocco-Hotels.html",
                            text: "Morocco Hotels"
                        },
                        {
                            href: "/hotel-deals/k134/Mozambique-Hotels.html",
                            text: "Mozambique Hotels"
                        },
                        {
                            href: "/hotel-deals/k75/Myanmar-Hotels.html",
                            text: "Myanmar Hotels"
                        },
                        {
                            href: "/hotel-deals/k228/Namibia-Hotels.html",
                            text: "Namibia Hotels"
                        },
                        {
                            href: "/hotel-deals/k116/Nepal-Hotels.html",
                            text: "Nepal Hotels"
                        },
                        {
                            href: "/hotel-deals/k120/Netherlands-Hotels.html",
                            text: "Netherlands Hotels"
                        },
                        {
                            href: "/hotel-deals/k200/New-Caledonia-Hotels.html",
                            text: "New Caledonia Hotels"
                        },
                        {
                            href: "/hotel-deals/k28/New-Zealand-Hotels.html",
                            text: "New Zealand Hotels"
                        },
                        {
                            href: "/hotel-deals/k83/Nicaragua-Hotels.html",
                            text: "Nicaragua Hotels"
                        },
                        {
                            href: "/hotel-deals/k168/Nigeria-Hotels.html",
                            text: "Nigeria Hotels"
                        },
                        {
                            href: "/hotel-deals/k211/Northern-Mariana-Islands-Hotels.html",
                            text: "Northern Mariana Islands Hotels"
                        },
                        {
                            href: "/hotel-deals/k32/Norway-Hotels.html",
                            text: "Norway Hotels"
                        },
                        {
                            href: "/hotel-deals/k212/Oman-Hotels.html",
                            text: "Oman Hotels"
                        },
                        {
                            href: "/hotel-deals/k71/Pakistan-Hotels.html",
                            text: "Pakistan Hotels"
                        },
                        {
                            href: "/hotel-deals/k217/Palestinian-Territories-Hotels.html",
                            text: "Palestinian Territories Hotels"
                        },
                        {
                            href: "/hotel-deals/k53/Panama-Hotels.html",
                            text: "Panama Hotels"
                        },
                        {
                            href: "/hotel-deals/k81/Papua-New-Guinea-Hotels.html",
                            text: "Papua New Guinea Hotels"
                        },
                        {
                            href: "/hotel-deals/k133/Paraguay-Hotels.html",
                            text: "Paraguay Hotels"
                        },
                        {
                            href: "/hotel-deals/k45/Peru-Hotels.html",
                            text: "Peru Hotels"
                        },
                        {
                            href: "/hotel-deals/k25/Philippines-Hotels.html",
                            text: "Philippines Hotels"
                        },
                        {
                            href: "/hotel-deals/k14/Poland-Hotels.html",
                            text: "Poland Hotels"
                        },
                        {
                            href: "/hotel-deals/k59/Portugal-Hotels.html",
                            text: "Portugal Hotels"
                        },
                        {
                            href: "/hotel-deals/k69/Qatar-Hotels.html",
                            text: "Qatar Hotels"
                        },
                        {
                            href: "/hotel-deals/k21/Republic-of-Korea-Hotels.html",
                            text: "Republic of Korea Hotels"
                        },
                        {
                            href: "/hotel-deals/k199/Reunion-Hotels.html",
                            text: "Reunion Hotels"
                        },
                        {
                            href: "/hotel-deals/k105/Romania-Hotels.html",
                            text: "Romania Hotels"
                        },
                        {
                            href: "/hotel-deals/k40/Russia-Hotels.html",
                            text: "Russia Hotels"
                        },
                        {
                            href: "/hotel-deals/k215/Saint-Barthelemy-Hotels.html",
                            text: "Saint Barthelemy Hotels"
                        },
                        {
                            href: "/hotel-deals/k188/Saint-Martin-French-Part--Hotels.html",
                            text: "Saint Martin (French Part) Hotels"
                        },
                        {
                            href: "/hotel-deals/k80/Saint-Vincent-and-the-Grenadines-Hotels.html",
                            text: "Saint Vincent and the Grenadines Hotels"
                        },
                        {
                            href: "/hotel-deals/k172/San-Marino-Hotels.html",
                            text: "San Marino Hotels"
                        },
                        {
                            href: "/hotel-deals/k64/Saudi-Arabia-Hotels.html",
                            text: "Saudi Arabia Hotels"
                        },
                        {
                            href: "/hotel-deals/k49/Senegal-Hotels.html",
                            text: "Senegal Hotels"
                        },
                        {
                            href: "/hotel-deals/k119/Serbia-Hotels.html",
                            text: "Serbia Hotels"
                        },
                        {
                            href: "/hotel-deals/k231/Seychelles-Hotels.html",
                            text: "Seychelles Hotels"
                        },
                        {
                            href: "/hotel-deals/k183/Singapore-Hotels.html",
                            text: "Singapore Hotels"
                        },
                        {
                            href: "/hotel-deals/k214/Sint-Maarten-Dutch-Part--Hotels.html",
                            text: "Sint Maarten (Dutch Part)"
                        },
                        {
                            href: "/hotel-deals/k174/Slovakia-Hotels.html",
                            text: "Slovakia Hotels"
                        },
                        {
                            href: "/hotel-deals/k171/Slovenia-Hotels.html",
                            text: "Slovenia Hotels"
                        },
                        {
                            href: "/hotel-deals/k122/South-Africa-Hotels.html",
                            text: "South Africa Hotels"
                        },
                        {
                            href: "/hotel-deals/k8/Spain-Hotels.html",
                            text: "Spain Hotels"
                        },
                        {
                            href: "/hotel-deals/k24/Sri-Lanka-Hotels.html",
                            text: "Sri Lanka Hotels"
                        },
                        {
                            href: "/hotel-deals/k36/St-Lucia-Hotels.html",
                            text: "St Lucia Hotels"
                        },
                        {
                            href: "/hotel-deals/k189/St-Kitts-and-Nevis-Hotels.html",
                            text: "St Kitts and Nevis Hotels"
                        },
                        {
                            href: "/hotel-deals/k131/Suriname-Hotels.html",
                            text: "Suriname Hotels"
                        },
                        {
                            href: "/hotel-deals/k33/Sweden-Hotels.html",
                            text: "Sweden Hotels"
                        },
                        {
                            href: "/hotel-deals/k10/Switzerland-Hotels.html",
                            text: "Switzerland Hotels"
                        },
                        {
                            href: "/hotel-deals/k20/Taiwan-Hotels.html",
                            text: "Taiwan Hotels"
                        },
                        {
                            href: "/hotel-deals/k95/Tajikistan-Hotels.html",
                            text: "Tajikistan Hotels"
                        },
                        {
                            href: "/hotel-deals/k155/Tanzania-Hotels.html",
                            text: "Tanzania Hotels"
                        },
                        {
                            href: "/hotel-deals/k26/Thailand-Hotels.html",
                            text: "Thailand Hotels"
                        },
                        {
                            href: "/hotel-deals/k152/Togo-Hotels.html",
                            text: "Togo Hotels"
                        },
                        {
                            href: "/hotel-deals/k91/Trinidad-and-Tobago-Hotels.html",
                            text: "Trinidad and Tobago Hotels"
                        },
                        {
                            href: "/hotel-deals/k60/Tunisia-Hotels.html",
                            text: "Tunisia Hotels"
                        },
                        {
                            href: "/hotel-deals/k34/Turkey-Hotels.html",
                            text: "Turkey Hotels"
                        },
                        {
                            href: "/hotel-deals/k191/Turks-and-Caicos-Islands-Hotels.html",
                            text: "Turks and Caicos Islands Hotels"
                        },
                        {
                            href: "/hotel-deals/k138/Uganda-Hotels.html",
                            text: "Uganda Hotels"
                        },
                        {
                            href: "/hotel-deals/k167/Ukraine-Hotels.html",
                            text: "Ukraine Hotels"
                        },
                        {
                            href: "/hotel-deals/k70/United-Arab-Emirates-Hotels.html",
                            text: "United Arab Emirates Hotels"
                        },
                        {
                            href: "/hotel-deals/k6/United-Kingdom-Hotels.html",
                            text: "United Kingdom Hotels"
                        },
                        {
                            href: "/hotel-deals/k1/United-States-Hotels.html",
                            text: "United States Hotels"
                        },
                        {
                            href: "/hotel-deals/k46/Uruguay-Hotels.html",
                            text: "Uruguay Hotels"
                        },
                        {
                            href: "/hotel-deals/k94/Uzbekistan-Hotels.html",
                            text: "Uzbekistan Hotels"
                        },
                        {
                            href: "/hotel-deals/k79/Vanuatu-Hotels.html",
                            text: "Vanuatu Hotels"
                        },
                        {
                            href: "/hotel-deals/k72/Venezuela-Hotels.html",
                            text: "Venezuela Hotels"
                        },
                        {
                            href: "/hotel-deals/k41/Vietnam-Hotels.html",
                            text: "Vietnam Hotels"
                        },
                        {
                            href: "/hotel-deals/k135/Zambia-Hotels.html",
                            text: "Zambia Hotels"
                        },
                        {
                            href: "/hotel-deals/k141/Zimbabwe-Hotels.html",
                            text: "Zimbabwe Hotels"
                        },
                        {
                            href: "",
                            text: ""
                        }
                    ]
                }
            }
        }
    },
    packages: {
        name: "PACKAGE",
        links: {
            exploreDeals: {
                caption: "Explore Package Deals",
                action: "Cheap Packages",
                items: [
                    {
                        href: "/deals/vacationpackages/theme-Hawaii-1790023.html",
                        text: "Hawaii Packages"
                    },
                    {
                        href: "/deals/vacationpackages/theme-All_Inclusive-1790004.html",
                        text: "All Inclusive Packages"
                    },
                    {
                        href: "/deals/vacationpackages/dest-United_States_Nevada_Las_Vegas-1700147.html",
                        text: "Nevada Packages"
                    },
                    {
                        href: "/deals/vacationpackages/theme-Florida-1790022.html",
                        text: "Florida Packages"
                    },
                    {
                        href: "/deals/vacationpackages/dest-United_States_Puerto_Rico_Puerto_Rico-1700216.html",
                        text: "Puerto Rico Packages"
                    },
                    {
                        href: "/deals/vacationpackages/theme-Caribbean-1790021.html",
                        text: "Caribbean Packages"
                    },
                    {
                        href: "/deals/vacationpackages/theme-Honeymoon-1790013.html",
                        text: "Honeymoon Packages"
                    },
                    {
                        href: "/deals/vacationpackages/dest-Bahamas_Bahamas-1700323.html",
                        text: "Bahamas Packages"
                    },
                    {
                        href: "/deals/vacationpackages/dest-United_States_Nevada_Las_Vegas-1700147.html",
                        text: "Las Vegas Packages"
                    },
                    {
                        href: "/deals/vacationpackages/dest-United_States_South_Carolina_Myrtle_Beach-1700182.html",
                        text: "Myrtle Beach Packages"
                    },
                    {
                        href: "/deals/vacationpackages/dest-United_States_Florida_Orlando-1700197.html",
                        text: "Orlando Packages"
                    },
                    {
                        href: "/deals/vacationpackages/dest-Mexico_Cancun-1700057.html",
                        text: "Cancun Packages"
                    }
                ]
            }
        }
    }
});

// EXTERNAL MODULE: ./src/components/WhyPricelineBanner/index.ts + 2 modules
var WhyPricelineBanner = __webpack_require__(57969);
// EXTERNAL MODULE: ./src/constants/reasons.tsx
var reasons = __webpack_require__(94228);
// EXTERNAL MODULE: ./src/components/MerchModuleWrapper/PromoBanners.tsx
var PromoBanners = __webpack_require__(8862);
// EXTERNAL MODULE: ./src/components/ScrollableDealModule/index.tsx + 1 modules
var ScrollableDealModule = __webpack_require__(89162);
;// CONCATENATED MODULE: ./src/components/Hotels/HotelsDealModule/constants.ts

var imageFolder = "https://s1.pclncdn.com/design-assets/next-landing/assets/images/home-deal-tiles/";
var HOTELS_DEAL_MODULE_CONTENT = {
    heading: "Don't miss these hotel deals",
    headingMobile: "Don't miss these deals!",
    dataArray: [
        {
            id: "HOTEL_DEAL_TILE_VEGAS",
            image: "".concat(imageFolder, "vegas.jpg?opto&auto=webp"),
            imageWebP: "".concat(imageFolder, "vegas.jpg?opto&auto=webp"),
            imageHeight: "284px",
            cityName: "Las Vegas",
            description: "",
            gaAction: "Hotel Deal Tile",
            gaCategory: constants_analytics/* ANALYTICS_CATEGORY_HOTELS */.T,
            productName: "GET YOUR GAME ON",
            priceAmount: 15,
            pricePrefix: "From",
            navArray: [
                {
                    href: "/hotel-deals/c3000015284/US/Nevada/Las-Vegas-Hotels.html",
                    target: "_blank"
                }
            ]
        },
        {
            id: "HOTEL_DEAL_TILE_CHICAGO",
            image: "".concat(imageFolder, "chicago.jpg?opto&auto=webp"),
            imageWebP: "".concat(imageFolder, "chicago.jpg?opto&auto=webp"),
            imageHeight: "284px",
            cityName: "Chicago",
            description: "",
            gaAction: "Hotel Deal Tile",
            gaCategory: constants_analytics/* ANALYTICS_CATEGORY_HOTELS */.T,
            productName: "ALL THAT JAZZ",
            priceAmount: 44,
            pricePrefix: "From",
            navArray: [
                {
                    href: "/hotel-deals/c3000005381/US/Illinois/Chicago-Hotels.html",
                    target: "_blank"
                }
            ]
        },
        {
            id: "HOTEL_DEAL_TILE_BOSTON",
            image: "".concat(imageFolder, "boston.jpg?opto&auto=webp"),
            imageWebP: "".concat(imageFolder, "boston.jpg?opto&auto=webp"),
            imageHeight: "284px",
            cityName: "Boston",
            description: "",
            gaAction: "Hotel Deal Tile",
            gaCategory: constants_analytics/* ANALYTICS_CATEGORY_HOTELS */.T,
            productName: "FREEDOM TRAIL FUN",
            priceAmount: 65,
            pricePrefix: "From",
            navArray: [
                {
                    href: "/hotel-deals/c3000008602/US/Massachusetts/Boston-Hotels.html",
                    target: "_blank"
                }
            ]
        }
    ]
};
/* harmony default export */ var constants = (HOTELS_DEAL_MODULE_CONTENT);

;// CONCATENATED MODULE: ./src/components/Hotels/HotelsDealModule/index.tsx





var HotelsDealModules = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        variation: "100",
        rowGap: "xl",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableDealModule/* default */.Z, {
            content: constants,
            isUsingNavArrows: false,
            handleNavOnClick: function(href) {
                return window.open(href);
            },
            isUsingPriceType: false,
            isUsingPricePrefix: true,
            isOpaque: false
        })
    });
};
/* harmony default export */ var HotelsDealModule = (HotelsDealModules);

// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Heading/Heading.js
var Heading = __webpack_require__(97331);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Button/Button.js
var Button = __webpack_require__(8316);
;// CONCATENATED MODULE: ./src/components/Hotels/ExpressDeal/ExpressDealPromo.tsx




function ExpressDealPromo() {
    var openModal = (0,useExpressDealModal/* default */.Z)().openModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        variation: "100",
        rowGap: "xl",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            boxShadowSize: "sm",
            p: 4,
            borderRadius: "xl",
            borderWidth: 0,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    bold: true,
                    textAlign: "center",
                    pb: 2,
                    color: "text.heading",
                    textStyle: "heading2",
                    children: "Save up to 60% on your next hotel"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    textAlign: "center",
                    pb: 3,
                    fontSize: 3,
                    color: "text.base",
                    children: "Get fast, easy savings on your next hotel with Priceline-exclusive Express Deals. Save up to 60% on your next hotel. Book and save!"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                        variation: "subtle",
                        size: "large",
                        "data-testid": "EXPRESS_DEAL_PROMO_BUTTON",
                        onClick: openModal,
                        children: "Search Express Deals"
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Hotels/HotelsContent/index.tsx
















var _exploreDeals = seo_product_links.HOTELS.links.exploreDeals, GLOBAL = _exploreDeals.GLOBAL, USA = _exploreDeals.USA, EUROPE = _exploreDeals.EUROPE, ASIA = _exploreDeals.ASIA, INTERNATIONAL = _exploreDeals.INTERNATIONAL;
var HotelsContent = function() {
    var toutBanners = (0,useContentful/* default */.Z)("toutBanners");
    var promoItems = (toutBanners === null || toutBanners === void 0 ? void 0 : toutBanners.items) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        size: "xl",
        mb: 5,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyPricelineBanner/* default */.Z, {
                isUsingNewLayout: true,
                content: reasons/* REASONS_HOTELS_LP */.Gz
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdContent/* AdContent */.j, {
                isUsingNewLayout: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdContent/* AdBox */.Z, {
                        type: "primary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "div-gpt-ad-1509978848821-0"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdContent/* AdBox */.Z, {
                        type: "secondary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "div-gpt-ad-1509978930813-0"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdContent/* AdBox */.Z, {
                        type: "tertiary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "div-gpt-ad-1509129580404-0"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailSignUp/* EmailSignUpComponent */.mK, {
                isUsingNewLayout: true,
                sourceId: "LANDING_HOTEL",
                category: constants_analytics/* ANALYTICS_CATEGORY_HOTELS */.T
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelsDealModule, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpressDealPromo, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoBanners/* default */.Z, {
                merchModules: promoItems
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppDownloadWrapper/* default */.Z, {
                category: constants_analytics/* ANALYTICS_CATEGORY_HOTELS */.T,
                isUsingNewLayout: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdBanner/* default */.Z, {
                isUsingNewLayout: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "div-gpt-ad-1509129866793-0"
                })
            }),
            [
                USA,
                EUROPE,
                ASIA,
                INTERNATIONAL,
                GLOBAL
            ].map(function(location) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SEOLinks, {
                    caption: location.caption,
                    category: constants_analytics/* ANALYTICS_CATEGORY_HOTELS */.T,
                    gaAction: location.action,
                    links: location.items
                }, location.action);
            })
        ]
    });
};
/* harmony default export */ var Hotels_HotelsContent = (HotelsContent);

// EXTERNAL MODULE: ./src/components/Hotels/SearchForm/utils.ts
var utils = __webpack_require__(84822);
// EXTERNAL MODULE: ./src/components/Hotels/SearchForm/Form.tsx + 8 modules
var Form = __webpack_require__(49515);
// EXTERNAL MODULE: ./src/components/Hotels/UrgencyMessage.tsx
var UrgencyMessage = __webpack_require__(95492);
// EXTERNAL MODULE: ./src/components/Hotels/FormHeadline.tsx
var FormHeadline = __webpack_require__(81987);
// EXTERNAL MODULE: ./src/components/SearchForm/Bumpers.tsx + 1 modules
var Bumpers = __webpack_require__(51197);
;// CONCATENATED MODULE: ./src/components/Hotels/HotelsDesktop.tsx

function HotelsDesktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  z-index: 1;\n  ",
        " {\n    display: flex;\n    align-items: flex-start;\n  }\n"
    ]);
    HotelsDesktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  position: relative;\n  margin: 16px;\n  min-height: 100px;\n  ",
        " {\n    width: 300px;\n    flex: none;\n    margin: 0 16px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


















var BlockFlex = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-63c9ead6-0"
})(HotelsDesktop_templateObject(), theme/* theme.mediaQueries.3 */.rS.mediaQueries[3]);
var HideAdUnit = (0,styled_components_browser_esm/* default */.ZP)(Hide/* default */.Z).withConfig({
    componentId: "sc-63c9ead6-1"
})(_templateObject1(), theme/* theme.mediaQueries.3 */.rS.mediaQueries[3]);
var HotelsDesktop = function() {
    var isOpen = (0,useExpressDealModal/* default */.Z)().isOpen;
    var ref = (0,react.useState)(), location = ref[0], setLocation = ref[1];
    var searchForm = (0,useContentfulSearchFormHeadlines/* default */.Z)("searchForm");
    var showMultiHotel = (0,useSeti/* default */.Z)("PKG_FE_HH_HOTEL_LANDING_PAGE", !isOpen) === "VARIANT" && !isOpen;
    var ref1;
    var subheadline = (ref1 = searchForm === null || searchForm === void 0 ? void 0 : searchForm.subheadline) !== null && ref1 !== void 0 ? ref1 : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpressDealModal/* default */.Z, {
                isModalOpen: isOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroImageParallax/* default */.Z, {
                isScrollable: true,
                gptId: "div-gpt-ad-1509978154282-0",
                slot: "/3102/priceline.dart/hotel_homepage_hero_image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlockFlex, {
                        mx: 3,
                        py: [
                            3,
                            null,
                            null,
                            null,
                            5
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                width: 1,
                                borderWidth: 0,
                                color: "background.lightest",
                                borderRadius: "2xl",
                                boxShadowSize: "xl",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchFormContext/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            p: 3,
                                            width: 1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                    pb: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHeadline/* default */.Z, {
                                                            location: location
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UrgencyMessage/* default */.Z, {
                                                            location: location,
                                                            my: "auto",
                                                            ml: 3
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading/* default */.Z, {
                                                    pb: 3,
                                                    tag: "h2",
                                                    color: "text.light",
                                                    text: subheadline,
                                                    textStyle: [
                                                        "subheading6",
                                                        null,
                                                        null,
                                                        null,
                                                        "subheading4"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                                                    onSubmit: utils/* handleSubmitForHotels */.Ky,
                                                    setLocation: setLocation,
                                                    showMultiHotel: showMultiHotel
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bumpers/* HotelsBumper */.np, {
                                            showMultiHotel: showMultiHotel
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HideAdUnit, {
                                xs: true,
                                sm: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Gpt */.B, {
                                    render: function() {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: "div-gpt-ad-1510170073577-0"
                                        });
                                    }
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                xs: true,
                sm: true,
                color: "background.lightest",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hotels_HotelsContent, {})
            })
        ]
    });
};
/* harmony default export */ var Hotels_HotelsDesktop = (HotelsDesktop);


/***/ }),

/***/ 95492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ UrgencyMessage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92833);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67113);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(23720);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);
/* harmony import */ var pcln_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(49011);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68464);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var popularCityIds = [
    3000015284,
    3000003349,
    3000003496,
    3000020633,
    3000002241,
    3000005381,
    3000002573,
    3000003311,
    3000014521,
    3000019836,
    3000002557,
    3000021763,
    3000016152,
    3000020856,
    3000003899,
    3000003192,
    3000012874,
    3000021212,
    3000021312,
    3000002228,
    3000008602,
    3000003249,
    3000001947,
    3000008434,
    3000022148,
    3000003431,
    3000006556,
    3000016809,
    3000021082,
    3000016799,
    3000016162,
    3000001349,
    3000019204,
    3000015300,
    3000019766,
    3000023880,
    3000023414,
    3000003032,
    3000003369,
    3000010974,
    3000019211,
    3000002250,
    3000014999,
    3000002244,
    3000020830,
    3000020605,
    3000020669,
    3000016338,
    3000020556,
    3000015474
];
var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs(function() {
    return {
        py: 1,
        px: 2
    };
}).withConfig({
    componentId: "sc-9f2c04eb-0"
})(_templateObject(), (0,pcln_design_system__WEBPACK_IMPORTED_MODULE_6__/* .getPaletteColor */ .ow)("border.base"));
var TopBooked = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        color: "background.light",
        borderRadius: "md"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                mr: 1,
                size: 16,
                color: "promoPrimary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                bold: true,
                color: "promoPrimary",
                fontSize: 0,
                textAlign: "center",
                m: "auto",
                children: "TOP BOOKED DESTINATION"
            })
        ]
    }));
};
function UrgencyMessage(_param) {
    var location = _param.location, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_param, [
        "location"
    ]);
    var ref;
    var prePopData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).prePopData;
    var endLocation = prePopData === null || prePopData === void 0 ? void 0 : (ref = prePopData.hotels) === null || ref === void 0 ? void 0 : ref.endLocation;
    var hasCity = !!(endLocation === null || endLocation === void 0 ? void 0 : endLocation.cityName) && (endLocation === null || endLocation === void 0 ? void 0 : endLocation.type) === "CITY";
    var cityId = Number(location === null || location === void 0 ? void 0 : location.cityID) || Number(endLocation === null || endLocation === void 0 ? void 0 : endLocation.cityID);
    var isPopularCity = hasCity && popularCityIds.includes(cityId);
    return isPopularCity ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TopBooked, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props)) : null;
}


/***/ }),

/***/ 8862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73779);



var PromoBanners = function(param) {
    var merchModules = param.merchModules, _isUsingNewLayout = param.isUsingNewLayout, isUsingNewLayout = _isUsingNewLayout === void 0 ? false : _isUsingNewLayout;
    return merchModules.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: merchModules.map(function(merchModule) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    content: merchModule,
                    isUsingNewLayout: isUsingNewLayout
                })
            }, merchModule === null || merchModule === void 0 ? void 0 : merchModule.internalName);
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (PromoBanners);


/***/ }),

/***/ 89162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ScrollableDealModule; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/theme/theme.js + 1 modules
var theme = __webpack_require__(15072);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Container/Container.js
var Container = __webpack_require__(32223);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Heading/Heading.js
var Heading = __webpack_require__(97331);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Hide/Hide.js
var Hide = __webpack_require__(87709);
// EXTERNAL MODULE: ./node_modules/@pcln/content-tile/dist/esm/index.js + 3 modules
var esm = __webpack_require__(60034);
// EXTERNAL MODULE: ./node_modules/@pcln/price-box/dist/esm/index.js + 11 modules
var dist_esm = __webpack_require__(46364);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./src/utils/rudder-stack.ts
var rudder_stack = __webpack_require__(964);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Button/Button.js
var Button = __webpack_require__(8316);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ArrowUp.js
var ArrowUp = __webpack_require__(25192);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ArrowDown.js
var ArrowDown = __webpack_require__(79016);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ArrowLeft.js
var ArrowLeft = __webpack_require__(88410);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ArrowRight.js
var ArrowRight = __webpack_require__(91209);
;// CONCATENATED MODULE: ./src/components/ScrollableDealModule/ArrowButton.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 40px;\n  width: 40px;\n\n  &&& {\n    border-radius: 50%;\n    padding: 8px 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var RoundButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.ZP).withConfig({
    componentId: "sc-8220fd98-0"
})(_templateObject());
var iconLookup = {
    up: ArrowUp/* default */.Z,
    down: ArrowDown/* default */.Z,
    left: ArrowLeft/* default */.Z,
    right: ArrowRight/* default */.Z
};
var ArrowButton = function(_param) {
    var direction = _param.direction, disabled = _param.disabled, onClick = _param.onClick, label = _param.label, props = (0,_object_without_properties/* default */.Z)(_param, [
        "direction",
        "disabled",
        "onClick",
        "label"
    ]);
    var IconDirection = iconLookup[direction];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        disabled: disabled,
        onClick: onClick,
        "data-testid": "arrow".concat(direction),
        "aria-label": label,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconDirection, {})
    }));
};
/* harmony default export */ var ScrollableDealModule_ArrowButton = (ArrowButton);

;// CONCATENATED MODULE: ./src/components/ScrollableDealModule/index.tsx
/* eslint-disable react/destructuring-assignment */ 






function ScrollableDealModule_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n"
    ]);
    ScrollableDealModule_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration-line: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var RemainingWidthFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-dbca5e55-0"
})(ScrollableDealModule_templateObject());
var NoWrapText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.ZP).withConfig({
    componentId: "sc-dbca5e55-1"
})(_templateObject1(), theme/* mediaQueries.1 */.w5[1]);
var NoDecorationLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-dbca5e55-2"
})(_templateObject2());
var TextSpan = Text/* default.span */.ZP.span;
var getImageTile = function(data, isUsingNavArrows, isUsingPricePrefix, isUsingPriceType, isOpaque, handleNavOnClick) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ImageTile */.a5, {
                height: data.imageHeight,
                image: data.image,
                imageWebP: data.imageWebP,
                navArray: data.navArray,
                handleNavOnClick: isUsingNavArrows && handleNavOnClick,
                isOpaque: isOpaque,
                borderRadius: "xl",
                rounded: "top"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                color: "text",
                p: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "space-between",
                        alignItems: "baseline",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                fontSize: 0,
                                children: data.productName
                            }),
                            !!data.strikePrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* StrikePrice */.Ch, {
                                price: data.strikePrice,
                                size: "small"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "space-between",
                        alignItems: "baseline",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NoWrapText, {
                                        fontSize: 3,
                                        fontWeight: "bold",
                                        children: data.cityName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                        fontSize: 0,
                                        mt: 1,
                                        children: data.description
                                    })
                                ]
                            }),
                            !!data.priceAmount && /*#__PURE__*/ (0,jsx_runtime.jsx)(NoWrapText, {
                                mt: "1px",
                                ml: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "baseline",
                                    children: [
                                        isUsingPricePrefix && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSpan, {
                                            mx: 2,
                                            color: "pricePrimary",
                                            fontSize: 4,
                                            fontWeight: "bold",
                                            children: data.pricePrefix
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* PriceBox */.bz, {
                                            priceSize: "small",
                                            price: data.priceAmount,
                                            priceColor: "pricePrimary",
                                            priceType: isUsingPriceType && "per person",
                                            alignItems: "right",
                                            toFixDecimal: 0
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
// TODO: improve the list of params using "deeper" React pattern
var parseDealTiles = function(dataArray, isUsingNavArrows, isUsingPriceType, isUsingPricePrefix, isOpaque, position, numDealsToDisplay, isTrips, handleNavOnClick, rudderstack) {
    var items = dataArray.slice(position, position + numDealsToDisplay);
    return items.map(function(data, index) {
        if (rudderstack) {
            (0,rudder_stack/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rudderstack), {
                position: position + 1 + index,
                category: "impression"
            }));
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            onClick: function() {
                analytics/* default.fireEvent */.Z.fireEvent({
                    action: data.gaAction,
                    category: data.gaCategory,
                    label: data.cityName
                });
                if (rudderstack) {
                    (0,rudder_stack/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rudderstack), {
                        position: position + 1 + index,
                        category: "click"
                    }));
                }
            },
            mx: [
                0,
                2
            ],
            borderRadius: "xl",
            boxShadowSize: "md",
            borderWidth: 0,
            width: [
                1,
                1 / numDealsToDisplay
            ],
            "data-testid": "deal-tile-".concat(data.cityName),
            children: isTrips ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                onClick: data.onTileClick,
                children: getImageTile(data, isUsingNavArrows, isUsingPricePrefix, isUsingPriceType, isOpaque, handleNavOnClick)
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoDecorationLink, {
                href: data.navArray[0].href,
                target: "_blank",
                children: getImageTile(data, isUsingNavArrows, isUsingPricePrefix, isUsingPriceType, isOpaque, handleNavOnClick)
            })
        }, "deal-tile-".concat(data.cityName));
    });
};
var ScrollableDealModule = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ScrollableDealModule, _Component);
    var _super = (0,_create_super/* default */.Z)(ScrollableDealModule);
    function ScrollableDealModule(props) {
        (0,_class_call_check/* default */.Z)(this, ScrollableDealModule);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            position: 0,
            numDealsToDisplay: 0
        };
        _this.handleLeftArrowClick = _this.updatePosition.bind((0,_assert_this_initialized/* default */.Z)(_this), false);
        _this.handleRightArrowClick = _this.updatePosition.bind((0,_assert_this_initialized/* default */.Z)(_this), true);
        _this.handleResize = _this.handleResize.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    var _proto = ScrollableDealModule.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.setState({
            numDealsToDisplay: // eslint-disable-next-line no-nested-ternary
            window.innerWidth >= 1024 ? 3 : window.innerWidth >= 640 ? 2 : 1
        });
        // eslint-disable-next-line @typescript-eslint/unbound-method
        window.addEventListener("resize", this.handleResize);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        window.removeEventListener("resize", this.handleResize);
    };
    _proto.handleResize = function handleResize() {
        var screenSize = window.innerWidth;
        if (screenSize >= 1024 && this.state.numDealsToDisplay !== 3) {
            this.setState({
                numDealsToDisplay: 3
            });
        } else if (screenSize >= 640 && screenSize < 1024 && this.state.numDealsToDisplay !== 2) {
            this.setState({
                numDealsToDisplay: 2
            });
        } else if (screenSize < 640 && this.state.numDealsToDisplay !== 1) {
            this.setState({
                numDealsToDisplay: 1
            });
        }
    };
    _proto.updatePosition = function updatePosition(shouldAdd) {
        if (shouldAdd) {
            var maxIndex = this.props.content.dataArray.length - this.state.numDealsToDisplay;
            var nextPosition = this.state.position + this.state.numDealsToDisplay;
            var position = Math.min(nextPosition, maxIndex);
            this.setState({
                position: position
            });
        } else {
            var nextPosition1 = this.state.position - this.state.numDealsToDisplay;
            var position1 = Math.max(nextPosition1, 0);
            this.setState({
                position: position1
            });
        }
    };
    _proto.render = function render() {
        var _props = this.props, content = _props.content, handleNavOnClick = _props.handleNavOnClick, _isUsingNavArrows = _props.isUsingNavArrows, isUsingNavArrows = _isUsingNavArrows === void 0 ? true : _isUsingNavArrows, _isUsingPriceType = _props.isUsingPriceType, isUsingPriceType = _isUsingPriceType === void 0 ? true : _isUsingPriceType, _isUsingPricePrefix = _props.isUsingPricePrefix, isUsingPricePrefix = _isUsingPricePrefix === void 0 ? false : _isUsingPricePrefix, _isOpaque = _props.isOpaque, isOpaque = _isOpaque === void 0 ? true : _isOpaque, _isTrips = _props.isTrips, isTrips = _isTrips === void 0 ? false : _isTrips, rudderstack = _props.rudderstack;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                    ml: 2,
                    pb: 24,
                    fontSize: 4,
                    fontWeight: "bold",
                    m: 0,
                    color: "text.heading",
                    textStyle: "heading2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                            xs: true,
                            children: content.heading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                            sm: true,
                            md: true,
                            lg: true,
                            xl: true,
                            xxl: true,
                            children: content.headingMobile
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "center",
                    alignItems: "center",
                    children: [
                        isUsingNavArrows && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                            xs: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableDealModule_ArrowButton, {
                                color: "primary",
                                direction: "left",
                                mr: 3,
                                disabled: this.state.position === 0,
                                onClick: this.handleLeftArrowClick,
                                label: "Scroll backward through the deals"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RemainingWidthFlex, {
                            flexDirection: [
                                "column",
                                "row"
                            ],
                            children: parseDealTiles(content.dataArray, isUsingNavArrows, isUsingPriceType, isUsingPricePrefix, isOpaque, this.state.position, this.state.numDealsToDisplay, isTrips, handleNavOnClick, rudderstack)
                        }),
                        isUsingNavArrows && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                            xs: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableDealModule_ArrowButton, {
                                color: "primary",
                                direction: "right",
                                disabled: this.state.position >= content.dataArray.length - this.state.numDealsToDisplay,
                                onClick: this.handleRightArrowClick,
                                label: "Scroll forward through the deals"
                            })
                        })
                    ]
                })
            ]
        });
    };
    return ScrollableDealModule;
}(react.Component);
/* harmony default export */ var components_ScrollableDealModule = (ScrollableDealModule);


/***/ }),

/***/ 57969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ WhyPricelineBanner_WhyPricelineBanner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/BlockLink/BlockLink.js
var BlockLink = __webpack_require__(21477);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Cars.js
var Cars = __webpack_require__(70895);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Discount.js
var Discount = __webpack_require__(72027);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Email.js
var Email = __webpack_require__(40124);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Help.js
var Help = __webpack_require__(45932);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Phone.js
var Phone = __webpack_require__(11761);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Verified.js
var Verified = __webpack_require__(26310);
;// CONCATENATED MODULE: ./src/components/WhyPricelineBanner/ReasonsToBelieveTile.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-57e866d0-0"
})(_templateObject());
var ConditionalBlockLink = function(param) {
    var children = param.children, href = param.href;
    return href ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockLink/* default */.Z, {
        href: href,
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
var ICONS = {
    Cars: Cars/* default */.Z,
    Discount: Discount/* default */.Z,
    Email: Email/* default */.Z,
    Help: Help/* default */.Z,
    Phone: Phone/* default */.Z,
    Verified: Verified/* default */.Z
};
var ReasonsToBelieveTile = function(param) {
    var headingFontColor = param.headingFontColor, _href = param.href, href = _href === void 0 ? "" : _href, iconColor = param.iconColor, subtextFontColor = param.subtextFontColor, tileContent = param.tileContent, tileCount = param.tileCount;
    var heading = tileContent.heading, iconName = tileContent.iconName, subtext = tileContent.subtext;
    var Icon = ICONS[iconName] || Box/* default */.Z;
    var paddingX = tileCount < 4 ? 4 : 2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBox, {
        width: 1 / tileCount,
        px: paddingX,
        py: 3,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalBlockLink, {
            href: href,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                    color: iconColor,
                    size: 28
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    caps: true,
                    color: headingFontColor,
                    textAlign: "center",
                    textStyle: "heading5",
                    py: 2,
                    children: heading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    color: subtextFontColor,
                    textAlign: "center",
                    textStyle: "paragraph",
                    children: subtext
                })
            ]
        })
    });
};
/* harmony default export */ var WhyPricelineBanner_ReasonsToBelieveTile = (ReasonsToBelieveTile);

// EXTERNAL MODULE: ./src/components/LayoutComponentWrapper/index.tsx
var LayoutComponentWrapper = __webpack_require__(47418);
;// CONCATENATED MODULE: ./src/components/WhyPricelineBanner/WhyPricelineBanner.tsx

function WhyPricelineBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1280px;\n"
    ]);
    WhyPricelineBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var StyledFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a458b5d3-0"
})(WhyPricelineBanner_templateObject());
var WhyPricelineBanner = function(param) {
    var _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "background.lightest" : _backgroundColor, content = param.content, _headingFontColor = param.headingFontColor, headingFontColor = _headingFontColor === void 0 ? "text.base" : _headingFontColor, _iconColor = param.iconColor, iconColor = _iconColor === void 0 ? "primary" : _iconColor, _subtextFontColor = param.subtextFontColor, subtextFontColor = _subtextFontColor === void 0 ? "text.light" : _subtextFontColor, _isUsingNewLayout = param.isUsingNewLayout, isUsingNewLayout = _isUsingNewLayout === void 0 ? false : _isUsingNewLayout;
    var tileCount = content.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutComponentWrapper/* default */.Z, {
        isUsingNewLayout: isUsingNewLayout,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFlex, {
            color: backgroundColor,
            justifyContent: "space-around",
            mx: "auto",
            tileCount: tileCount,
            children: content && content.map(function(tileContent) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyPricelineBanner_ReasonsToBelieveTile, {
                    href: tileContent.href,
                    headingFontColor: headingFontColor,
                    iconColor: iconColor,
                    subtextFontColor: subtextFontColor,
                    tileContent: tileContent,
                    tileCount: tileCount
                }, tileContent.iconName);
            })
        })
    });
};
/* harmony default export */ var WhyPricelineBanner_WhyPricelineBanner = (WhyPricelineBanner);

;// CONCATENATED MODULE: ./src/components/WhyPricelineBanner/index.ts



/***/ }),

/***/ 94228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gz": function() { return /* binding */ REASONS_HOTELS_LP; },
/* harmony export */   "YT": function() { return /* binding */ REASONS_HOME; },
/* harmony export */   "_$": function() { return /* binding */ REASONS_HOME_EXPERIMENT; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var FLEXIBLE_BOOKING_TILE = {
    iconName: "Verified",
    heading: "Flexible Bookings",
    subtext: "Plans change. That’s why we offer free cancellation on most hotels & rental cars."
};
var DISCOUNT_TILE = {
    iconName: "Discount",
    heading: "Incredible Deals",
    subtext: "Check out with confidence. Priceline members always get our best price.",
    href: "https://help.priceline.com/what-is-best-price-guarantee-Sys6cJ86u"
};
var DISCOUNT_HOTELS_LP_TILE = {
    iconName: "Discount",
    heading: "Book With Confidence",
    subtext: "Priceline members always get our best price.",
    href: "https://help.priceline.com/what-is-best-price-guarantee-Sys6cJ86u"
};
var RC_TILE = {
    iconName: "Cars",
    heading: "No Flight? No Problem",
    subtext: "Bundle hotel & rental car deals to build your perfect getaway. No airtime required."
};
var PHONE_HOTELS_LP_VARIANT_TILE = {
    iconName: "Phone",
    heading: "Unlock Special Discounts",
    subtext: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            "1 in 4 people save 20% or more over the phone. Call Now.",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
            "(833) 378-0470"
        ]
    })
};
var HELP_TILE = {
    iconName: "Help",
    heading: "Help 24/7",
    subtext: "We’re always here for you – reach us 24 hours a day, 7 days a week.",
    href: "https://help.priceline.com"
};
var REASONS_HOME = [
    FLEXIBLE_BOOKING_TILE,
    DISCOUNT_TILE,
    RC_TILE,
    HELP_TILE
];
var REASONS_HOME_EXPERIMENT = [
    FLEXIBLE_BOOKING_TILE,
    RC_TILE,
    DISCOUNT_TILE,
    HELP_TILE
];
var REASONS_HOTELS_LP = [
    FLEXIBLE_BOOKING_TILE,
    DISCOUNT_HOTELS_LP_TILE,
    PHONE_HOTELS_LP_VARIANT_TILE,
    HELP_TILE
];


/***/ }),

/***/ 964:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var fireRudderstackEvent = function(rudderstack) {
    if (rudderstack.subType) {
        var ref;
        var event = rudderstack.subType;
        (ref = window.rudderanalytics) === null || ref === void 0 ? void 0 : ref.track(event, rudderstack);
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (fireRudderstackEvent);


/***/ }),

/***/ 21477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87379);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40869);
var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var BlockLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_Link__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  color: inherit;\n  text-decoration: none;\n"], ["\n  display: block;\n  color: inherit;\n  text-decoration: none;\n"])));
BlockLink.displayName = 'BlockLink';
BlockLink.propTypes = _Link__WEBPACK_IMPORTED_MODULE_1__/* ["default"].propTypes */ .Z.propTypes;
/* harmony default export */ __webpack_exports__["Z"] = (BlockLink);
var templateObject_1;
//# sourceMappingURL=BlockLink.js.map

/***/ }),

/***/ 40124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51557);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
var _excluded = ["size", "title", "desc", "titleId", "descId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var BaseComponent = function BaseComponent(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = _objectWithoutProperties(_ref, _excluded);

  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
  }));
};

var SvgEmail = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(BaseComponent).withConfig({
  displayName: "Email__SvgEmail",
  componentId: "sc-1gpgoec-0"
})(["outline:none;"]);
SvgEmail.isIcon = true;
SvgEmail.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgEmail);

/***/ }),

/***/ 49011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51557);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
var _excluded = ["size", "title", "desc", "titleId", "descId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var BaseComponent = function BaseComponent(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = _objectWithoutProperties(_ref, _excluded);

  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M3.5 18.5l6-6 4 4L22 6.9l-1.4-1.4-7.1 8-4-4L2 17l1.5 1.5z"
  }));
};

var SvgGraph = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(BaseComponent).withConfig({
  displayName: "Graph__SvgGraph",
  componentId: "sc-191p7mb-0"
})(["outline:none;"]);
SvgGraph.isIcon = true;
SvgGraph.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgGraph);

/***/ }),

/***/ 45932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51557);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
var _excluded = ["size", "title", "desc", "titleId", "descId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var BaseComponent = function BaseComponent(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = _objectWithoutProperties(_ref, _excluded);

  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1 17h-2v-2h2v2zm2.1-7.8l-.9.9c-.8.8-1.2 1.4-1.2 2.9h-2v-.5c0-1.1.4-2.1 1.2-2.8l1.2-1.3c.4-.3.6-.8.6-1.4 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.2 1.8-4 4-4s4 1.8 4 4c0 .9-.4 1.7-.9 2.2z"
  }));
};

var SvgHelp = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(BaseComponent).withConfig({
  displayName: "Help__SvgHelp",
  componentId: "sc-o9gnto-0"
})(["outline:none;"]);
SvgHelp.isIcon = true;
SvgHelp.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgHelp);

/***/ }),

/***/ 11761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51557);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
var _excluded = ["size", "title", "desc", "titleId", "descId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var BaseComponent = function BaseComponent(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = _objectWithoutProperties(_ref, _excluded);

  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.5 0 1 .4 1 1V20c0 .5-.5 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.2.2 2.5.6 3.6.1.3 0 .7-.2 1l-2.3 2.2z"
  }));
};

var SvgPhone = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(BaseComponent).withConfig({
  displayName: "Phone__SvgPhone",
  componentId: "sc-kt0n4v-0"
})(["outline:none;"]);
SvgPhone.isIcon = true;
SvgPhone.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgPhone);

/***/ }),

/***/ 26310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51557);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
var _excluded = ["size", "title", "desc", "titleId", "descId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var BaseComponent = function BaseComponent(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = _objectWithoutProperties(_ref, _excluded);

  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 2L4 5.6v5.5c0 5 3.4 9.8 8 10.9 4.6-1.1 8-5.9 8-10.9V5.6L12 2zm-1.8 14.5l-3.6-3.6 1.3-1.3 2.3 2.3 5.9-6 1.3 1.3-7.2 7.3z"
  }));
};

var SvgVerified = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(BaseComponent).withConfig({
  displayName: "Verified__SvgVerified",
  componentId: "sc-772qot-0"
})(["outline:none;"]);
SvgVerified.isIcon = true;
SvgVerified.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgVerified);

/***/ })

}]);